<template>
  <section
    ref="container"
    v-loading="loading"
    class="page-container"
    @click="()=>{setPolicy=false}">
    <div
      class="main-header ">
      <div
        class="flex-sb type-margin">
        <div class="">
          <div class="header-title flex">
            <span
              v-if="merchant_platform"
              class="table-icon__img icon mg-r-15">
              <img :src="getOptionName('serverTypeIcon',detailData.merchant_platform)" >
            </span>
            <span class="icon" >
              <font-awesome-icon
                icon="ticket-alt"
                class="icon-color"/>
            </span>
            <span class="icon" >
              <span class="button-radius">{{detailData.type_language}}</span>
            </span>
            <span
              class="hcid ticket-number"> <span class="number-color">{{detailData.ticket_number}}</span></span>
          </div>

          <div class="header-title flex">
            <h3>{{ detailData.subject }}</h3>
          </div>
          <div class="flex flex-inline">
            <div>
              <span
                class="status-bar-span"
                :class="{
                  'pending':detailData.status==2,
                  'yellow':detailData.status==1,
                  'green':detailData.status==3,
                  'red':isVoidTicket,
                }"
              >{{detailData.status_language}}</span>
            </div>
            <div>
              <span
                class="span-status-stts"
                :class="{
                  'orange-light': [5].includes(relation.stts)&&isRenewalTicket||[1, 3,5].includes(detailData.stts)&&detailData.type==2||detailData.type==3&&[101,301].includes(detailData.stts),
                  'yellow-dark':[3].includes(relation.stts)&&isRenewalTicket||[0].includes(detailData.stts)&&detailData.type==2||detailData.type==4&&[1].includes(detailData.stts)||(detailData.type==5||detailData.type==6||detailData.type==3)&&[0].includes(detailData.stts),
                  'blue': [2].includes(relation.stts)&&isRenewalTicket||[2,4].includes(detailData.stts)&&detailData.type==2||detailData.type==4&&[4].includes(detailData.stts)||detailData.type==3&&[201,501].includes(detailData.stts)||detailData.type==6&&[1].includes(detailData.stts),
                  'green': [7].includes(relation.stts)&&isRenewalTicket||[6].includes(detailData.stts)&&detailData.type==2||detailData.type==4&&[2].includes(detailData.stts)||detailData.type==3&&[601].includes(detailData.stts)||detailData.type==5&&[1].includes(detailData.stts)||detailData.type==6&&[3].includes(detailData.stts),
                  'red':[4,6].includes(relation.stts)&&isRenewalTicket||[6].includes(detailData.stts)&&detailData.type==3||detailData.type==4&&[3].includes(detailData.stts)||detailData.type==3&&[401].includes(detailData.stts),
                  'purple': [2].includes(detailData.stts)&&detailData.type==6,
                  'gray':[1].includes(relation.stts)&&isRenewalTicket
                }"
              >{{isRenewalTicket?relation.stts_language:detailData.stts_language}}</span>
            </div>
            <span class="header-date">Created</span>
            <span class="number-color number-fontsize">{{ detailData.created_at }}</span>
            <span class="header-date">Updated</span>
            <span class="number-color number-fontsize">{{ detailData.updated_at }}</span>

          </div>
        </div>
        <div class="form-item">
          <span>Assignee</span>
          <span>

            <v-select
              v-model="detailData.cs_id"
              icon="user-nurse"
              :list="assigneeList"
              :clearable="true"
              @change="selectAssignee"
            />
          </span>
        </div>
      </div>

      <div>
        <!-- Refer Case -->
        <div  v-if="showMain&&!showMainRight">
          <section v-if="type === 2">
            <el-tabs v-model="activeTab">
              <el-tab-pane
                v-for="(tab, index) in referTab"
                :key="index"
                :label="tab.label"
                :name="String(tab.name)"
              ></el-tab-pane>
            </el-tabs>
          </section>
          <section v-if="![1,2,6].includes(type)">
            <el-tabs v-model="activeTab">
              <el-tab-pane
                v-for="(tab, index) in businessTab"
                :key="index"
                :label="tab.label"
                :name="String(tab.name)"
              ></el-tab-pane>
            </el-tabs>
          </section>
          <section v-if="type == 6">
            <el-tabs v-model="activeTab">
              <el-tab-pane
                v-for="(tab, index) in claimTab"
                :key="index"
                :label="tab.label"
                :name="String(tab.name)"
              ></el-tab-pane>
            </el-tabs>
          </section>
          <section v-if="type == 1">
            <el-tabs v-model="activeTab">
              <el-tab-pane
                v-for="(tab, index) in generalTab"
                :key="index"
                :label="tab.label"
                :name="String(tab.name)"
              ></el-tab-pane>
            </el-tabs>
          </section>
        </div>
      </div>
    </div>

    <div class="warning">
      <block-warning
        v-if="customer_profile.block_data && customer_profile.block_data.length"
        :customerProfile="customer_profile"></block-warning>
    </div>

    <div
      class="main-container">
      <div
        v-if="showMain&&!showMainRight"
        class="main-col">
        <div class="middle-col">
          <v-serviced-progress
            v-if="merchant_platform"
            :agency-name="detailData.agency_name"
            class="mg-b-20"
            :is-fina="isFina"></v-serviced-progress>
          <template v-if="status==3">
            <div
              class="status-bar resolved"
            >
              <div class="status-title">
                <!--                <span v-if="is_snooze == 1">-->
                <!--                  <font-awesome-icon icon="stopwatch" />-->
                <!--                  This ticket has been snoozed until {{ detailData.snooze_until }}.-->
                <!--                </span>-->
                <span >
                  <font-awesome-icon
                    icon="check"
                    class="check"/>
                  This ticket has been marked as resolved.
                </span>
              </div>
              <div>
                <!--                <template v-if="is_snooze == 1">-->
                <!--                  <v-button @click="handlerDialog('snooze-ticket')">Edit Snooze</v-button>-->
                <!--                  <v-button @click="network().setTicketUnsnooze(0)">Unsnooze</v-button>-->
                <!--                </template>-->
                <template >
                  <v-button @click="network().reopenTicket(0)">Reopen</v-button>
                </template>
              </div>
            </div>
          </template>
          <section v-if="type === 1">
            <div
              v-show="activeTab === '1'">
              <support-log
                :logsData="supportLogsData"
                @change="changeSupportLogType" />
            </div>
            <div v-show="activeTab == '2'">
              <internal-document
                :ticket-id='ticketId'
                :list='detailData.internal_doc'
                :customer="customer"
                :form="detailData.relation"
                :type="type"
                :is-ticket="true"
                @updateDetail="handlerGetTicketDetail">
              </internal-document>
            </div>
          </section>
          <section  v-else-if="type === 2">
            <div
              v-show="activeTab === '1'">
              <request-detail
                :type="type"
                :record="detailData.status_record"
                :disabledEdit="disabledEdit"
                :isAttachCustomer="isAttachCustomer"
                :form="detailData.relation"
                :policy-info="detailData.policy_info"
                :refer-detail="referDetail"
                :customer="customer_profile"
                @editClaim="handleEditClaimStatus"
                @edit="event().handlerRequestEdit(2)"/>
            </div>
            <div v-show="activeTab === '2'">
              <document-info
                :form="documentData"
                :disabledEdit="disabledEdit"
                @edit="event().handlerRequestEdit(2)" />
            </div>
            <div v-show="activeTab === '5'">
              <cause-list
                :list="relation.refer_reason"
              />
            </div>
            <div v-show="activeTab == '4'">
              <internal-document
                :ticket-id='ticketId'
                :list='detailData.internal_doc'
                :customer="customer"
                :form="detailData.relation"
                :type="type"
                :is-ticket="true"
                @updateDetail="handlerGetTicketDetail">
              </internal-document>
            </div>
            <div v-show="activeTab === '3'">
              <support-log
                :logsData="supportLogsData"
                @change="changeSupportLogType" />
            </div>
          </section>
          <section v-else-if="type===6">
            <div v-show="activeTab === '1'">
              <request-detail
                :disabledEdit="disabledRequestEdit"
                :isAttachCustomer="isAttachCustomer"
                :type="type"
                :record="detailData.status_record"
                :form="detailData.relation"
                :policy-info="detailData.policy_info"
                @editClaim="handleEditClaimStatus"
                @edit="event().handlerRequestEdit(type)"/>
            </div>
            <div v-if="activeTab == 2">
              <support-log
                :logsData="supportLogsData"
                is-claim
                @change="changeSupportLogType" />
            </div>
          </section>
          <!-- Business Endorsoment credit transfer Claim -->
          <section v-else>
            <div v-show="activeTab === '1'">
              <template v-if="isRenewalTicket">
                <renew-ticket-detail
                  :form="detailData"
                  @update="updateTicketDetail"
                  @edit="handleEdit"></renew-ticket-detail>
              </template>
              <template v-else>
                <request-detail
                  :disabledEdit="disabledRequestEdit"
                  :isAttachCustomer="isAttachCustomer"
                  :type="type"
                  :record="detailData.status_record"
                  :form="detailData.relation"
                  :policy-info="detailData.policy_info"
                  @editClaim="handleEditClaimStatus"
                  @edit="event().handlerRequestEdit(type)"/>
              </template>
            </div>
            <div v-show="activeTab == '2' ">
              <internal-document
                :manual_id='detailData.relation.id'
                :customer="customer"
                :form="detailData.relation"
                :ticket-id="ticketId"
                :type="type"
                :is-ticket="type!=5"
                :list="type==5?detailData.relation.internal_doc:detailData.internal_doc"
                @updateDetail="handlerGetTicketDetail"></internal-document>
            </div>
            <div v-show="activeTab === '3'">
              <support-log
                :logsData="supportLogsData"
                @change="changeSupportLogType" />
            </div>

          </section>

        </div>
        <div class="right-col">
          <template v-if="!isNewSME">
            <template  v-if="type === 2">
              <!-- Bought Buyable Quote  v-if="type === 2"  -->
              <div
                v-if="showBought"
                class="bg-block bg-sky-blue border-left-success">
                <p>A Buyable Quote of this ticket has been purchased.</p>
                <v-button
                  v-if="!isSignature"
                  icon="eye"
                  @click="goViewQuote(detailData.relation.order_id)">View Quote</v-button>
                <v-button
                  v-else
                  icon="eye"
                  @click="goViewPolicy(detailData.relation.order_id)">View Policy</v-button>

                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>

                <div
                  v-if="!isSignature"
                  class="flex button-list button-list-width-half">
                  <v-button
                    size="small"
                    icon="link"
                    class="button-margin"
                    @click="handlerSend"
                  ><span class="send-color">Signature</span>
                  </v-button>
                  <v-button
                    class="button-margin"
                    @click="handlerContact(1)"
                  >
                    <font-awesome-icon icon="sms"></font-awesome-icon>
                  </v-button>
                  <v-button
                    class="button-margin"
                    @click="handlerContact(3)"
                  >
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                  </v-button>
                </div>
              </div>
              <!-- During payment lock -->
              <div
                v-if="showPaymentLock"
                class="bg-block"
                :class="{
                  'bg-sky-blue':!wainting_sign,
                  'border-left-warning':!wainting_sign,
                  'bg-warning__yellow':wainting_sign,
                }"
              >
                <p v-if="!wainting_sign">One of the quote(s) is in the payment process.</p>
                <template v-else>
                  <p class="color-dark">Waiting For Signature</p>
                  <p class="fw-400 color-dark ">A quote has been paid, and waiting for the signature.</p>
                  <div class="flex flex__button">
                    <v-button
                      v-if="!isSignature"
                      class="width-80"
                      icon="eye"
                      gray
                      @click="goViewQuote(detailData.relation.order_id)">View Quote</v-button>
                    <v-button
                      v-else
                      icon="eye"
                      class="width-80"
                      :disabled="showPaymentLock"
                      gray
                      @click="goViewPolicy(detailData.relation.order_id)">View Policy</v-button>

                    <v-button
                      v-show="showPdf"
                      icon="file-pdf"
                      class="mg-l-10"
                      gray
                      @click="event().downloadPdf()">
                      PDFs
                    </v-button>
                  </div>
                  <template v-if="!isSignature">
                    <div class="flex button-list button-list-width-half">
                      <v-button
                        size="small"
                        icon="link"
                        gray
                        class="button-margin width-80"
                        @click="handlerSend"
                      ><span class="send-color">Signature</span>
                      </v-button>
                      <v-button
                        class="button-margin"
                        gray
                        @click="handlerContact(1)"
                      >
                        <font-awesome-icon   icon="sms"></font-awesome-icon>
                      </v-button>
                      <v-button
                        gray
                        @click="handlerContact(3)"
                      >
                        <font-awesome-icon   icon="envelope"></font-awesome-icon>
                      </v-button>

                    </div>
                    <v-button
                      class="width-fill"
                      icon="forward"
                      gray
                      @click="handlerSkip">
                      Skip
                    </v-button>
                  </template>
                </template>
              </div>
              <!-- Replied Buyable Quote -->
              <div
                v-if="showBuyable"
                class="bg-block bg-sky-blue">
                <p>Buyable Quote(s) have been replied in this support ticket.</p>
                <v-button
                  blue
                  icon="money-bill-wave"
                  @click="onBuyQuote">Pay on behalf</v-button>
                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  gray
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>
                <div>
                  <v-button
                    class="button-margin"
                    gray
                    @click="handlerContact(1, 'Buyable')"
                  >
                    <font-awesome-icon icon="sms"></font-awesome-icon>
                  </v-button>
                  <v-button
                    class="button-margin"
                    gray
                    @click="handlerContact(3, 'Buyable')"
                  >
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                  </v-button>
                </div>
                <v-button
                  v-if="!isSMEProduct"
                  warning-btn
                  icon="level-down-alt"
                  @click="onDowngradeQuoteClick">Downgrade to Price Quote</v-button>
                <v-button
                  gray
                  icon="money-check-alt"
                  @click="onEditRepliedClick">View Replied Quotes</v-button>
                <v-button
                  icon="ban"
                  gray
                  @click="onWithdrawClick">Withdraw Quote</v-button>
              </div>
              <!-- Replied Price Quote + Client Chose -->
              <div
                v-if="showRepliedChose"
                class="bg-block bg-small-blue border-left-blue">
                <p>The client has chosen one of the replied Price Quote(s).</p>
                <v-button
                  v-if="!isSMEProduct"
                  type="primary"
                  icon="level-up-alt"
                  :disabled="disabledUpgradBtn"
                  @click="onUpgradeQuoteClick">Upgrade to Buyable Quote</v-button>
                <v-button
                  icon="money-check-alt"
                  @click="onEditRepliedClick">Edit Replied Quotes</v-button>
                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>
                <v-button
                  icon="ban"
                  @click="onWithdrawClick">Withdraw Quote</v-button>
              </div>
              <!-- Replied Quote -->
              <div
                v-if="showReplied"
                class="bg-block bg-small-blue">
                <p>Pricing Quote(s) have been replied in this support ticket.</p>
                <v-button
                  icon="money-check-alt"
                  @click="onEditRepliedClick">Edit Replied Quotes</v-button>
                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>
                <v-button
                  icon="ban"
                  @click="onWithdrawClick">Withdraw Quote</v-button>
                <v-button
                  type="primary"
                  icon="level-up-alt"
                  :disabled="disabledUpgradBtn"
                  @click="onUpgradeQuoteClick">Upgrade to Buyable Quote</v-button>

                <v-button
                  icon="comment"
                  @click="onSendReferralSms">Send Notification SMS</v-button>
              </div>
              <div
                v-if="showDraft"
                class="bg-gray">
                <p>Quote(s) have been saved in this support ticket.</p>
                <v-button
                  icon="money-check-alt"
                  @click="onEditDraftClick">Edit Saved Quotes</v-button>
              </div>
            </template>
          </template>
          <!-- 新SME 2024.1.26-->
          <template v-else>
            <template  v-if="type === 2">
              <div
                v-if="showBought"
                class="bg-block bg-sky-blue border-left-success">
                <p>A Buyable Quote of this ticket has been purchased.</p>
                <v-button
                  v-if="!isSignature"
                  icon="eye"
                  @click="goViewQuote(detailData.relation.order_id)">View Quote</v-button>
                <v-button
                  v-else
                  icon="eye"
                  @click="goViewPolicy(detailData.relation.order_id)">View Policy</v-button>

                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>

                <div
                  v-if="!isSignature"
                  class="flex button-list button-list-width-half">
                  <v-button
                    size="small"
                    icon="link"
                    class="button-margin"
                    @click="handlerSend"
                  ><span class="send-color">Signature</span>
                  </v-button>
                  <v-button
                    class="button-margin"
                    @click="handlerContact(1)"
                  >
                    <font-awesome-icon icon="sms"></font-awesome-icon>
                  </v-button>
                  <v-button
                    class="button-margin"
                    @click="handlerContact(3)"
                  >
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                  </v-button>
                </div>
              </div>
              <!-- During payment lock -->
              <div
                v-if="showPaymentLock"
                class="bg-block"
                :class="{
                  'bg-sky-blue':!wainting_sign,
                  'border-left-warning':!wainting_sign,
                  'bg-warning__yellow':wainting_sign,
                }"
              >
                <p v-if="!wainting_sign">One of the quote(s) is in the payment process.</p>
                <template v-else>
                  <p class="color-dark">Waiting For Signature</p>
                  <p class="fw-400 color-dark ">A quote has been paid, and waiting for the signature.</p>
                  <div class="flex flex__button">
                    <v-button
                      v-if="!isSignature"
                      class="width-80"
                      icon="eye"
                      gray
                      @click="goViewQuote(detailData.relation.order_id)">View Quote</v-button>
                    <v-button
                      v-else
                      icon="eye"
                      class="width-80"
                      gray
                      @click="goViewPolicy(detailData.relation.order_id)">View Policy</v-button>

                    <v-button
                      v-show="showPdf"
                      icon="file-pdf"
                      gray
                      @click="event().downloadPdf()">
                      PDFs
                    </v-button>
                  </div>
                  <template v-if="!isSignature">
                    <div class="flex button-list button-list-width-half">
                      <v-button
                        size="small"
                        icon="link"
                        gray
                        class="button-margin width-80"
                        @click="handlerSend"
                      ><span class="send-color">Signature</span>
                      </v-button>
                      <v-button
                        class="button-margin"
                        gray
                        icon="sms"
                        @click="handlerContact(1)"
                      >
                      </v-button>
                      <v-button
                        gray
                        icon="envelope"
                        @click="handlerContact(3)"
                      >
                      </v-button>

                    </div>
                    <v-button
                      class="width-fill"
                      icon="forward"
                      gray
                      @click="handlerSkip">
                      Skip
                    </v-button>
                  </template>
                </template>
              </div>
              <!-- Replied Buyable Quote -->
              <div
                v-if="showBuyable"
                class="bg-block bg-small-blue">
                <p class="color-dark fs-14 fw-600">Buyable</p>
                <p class="fw-400">Buyable Quote(s) have been replied in this support ticket.</p>
                <v-button
                  icon="eye"
                  class="width-fill"
                  gray
                  @click="onEditRepliedClick">View Quotes</v-button>
                <v-button
                  icon="ban"
                  class="width-fill"
                  gray
                  @click="onWithdrawClick">Withdraw Quote</v-button>
              </div>
              <!-- Replied Price Quote + Client Chose -->
              <div
                v-if="showRepliedChose"
                class="bg-block bg-small-blue border-left-blue">
                <p>The client has chosen one of the replied Price Quote(s).</p>
                <v-button
                  v-if="!isSMEProduct"
                  type="primary"
                  icon="level-up-alt"
                  :disabled="disabledUpgradBtn"
                  @click="onUpgradeQuoteClick">Upgrade to Buyable Quote</v-button>
                <v-button
                  icon="money-check-alt"
                  @click="onEditRepliedClick">Edit Replied Quotes</v-button>
                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>
                <v-button
                  icon="ban"
                  @click="onWithdrawClick">Withdraw Quote</v-button>
              </div>
              <!-- Replied Quote -->
              <div
                v-if="showReplied"
                class="bg-block bg-small-blue">
                <p>Pricing Quote(s) have been replied in this support ticket.</p>
                <v-button
                  icon="money-check-alt"
                  @click="onEditRepliedClick">Edit Replied Quotes</v-button>
                <v-button
                  v-show="showPdf"
                  icon="file-pdf"
                  @click="event().downloadPdf()">
                  PDFs
                </v-button>
                <v-button
                  icon="ban"
                  @click="onWithdrawClick">Withdraw Quote</v-button>
                <v-button
                  type="primary"
                  icon="level-up-alt"
                  :disabled="disabledUpgradBtn"
                  @click="onUpgradeQuoteClick">Upgrade to Buyable Quote</v-button>

                <v-button
                  icon="comment"
                  @click="onSendReferralSms">Send Notification SMS</v-button>
              </div>
              <div
                v-if="showDraft"
                class="bg-gray">
                <p>Quote(s) have been saved in this support ticket.</p>
                <v-button
                  icon="money-check-alt"
                  @click="onEditDraftClick">Edit Saved Quotes</v-button>
              </div>
            </template>
          </template>
          <!-- ####新SME 2024.1.26-->

          <template v-if="type === 3">
            <div
              v-if="isEndorsementUndone"
              class="bg-block bg-danger">
              <p>This endorsement was undone. To begin endorsment, please create a new endorsement ticket.</p>
            </div>
            <!-- only show if another ticket transferred $$ to this ticket -->
            <!-- <div
              class="bg-block bg-warning">
              <p>
                This ticket has funds saved.
                <br />
                <span>$12.34</span>
              </p>
              <v-button
                icon="hand-holding-usd"
                @click="handlerDialog('the-refund')">Refund Partial/All</v-button>
              <v-button
                icon="eye">View Policy Cheques</v-button>
              <v-button
                icon="share"
                @click="handlerDialog('transfer-funds')">Transfer All to Other Ticket</v-button>
            </div> -->
            <div
              v-if="isEndorsementIssuing"
              class="bg-block bg-sky-blue border-left-success">
              <p>This endorsement is being issued.</p>
              <div>
                <v-button
                  icon="eye"
                  @click="goViewPolicy(detailData.relation.endorse_order_id)">View Policy</v-button>
              </div>
              <div>
                <v-button
                  icon="eye"
                  @click="onViewEndorsementQuote">View Endorsement Quote</v-button>
              </div>
              <!-- <v-button
                type="success"
                icon="check"
                @click="onMarkResolved">
                Mark As Resolved
              </v-button> -->
              <div>
                <v-button
                  type="success"
                  icon="check"
                  @click="onMarkEndorsed">
                  Mark As Endorsed
                </v-button>
              </div>
            </div>
            <div
              v-if="isEndorsementCompleted"
              class="bg-block bg-sky-blue border-left-success">
              <p>This endorsement has been completed.</p>
              <div>
                <v-button
                  icon="eye"
                  @click="goViewPolicy(detailData.relation.endorse_order_id)">View Policy</v-button>
              </div>
              <div>
                <v-button
                  icon="eye"
                  @click="goViewPolicy(detailData.relation.endorse_order_id, 'Invoice')">View Policy & Invoices</v-button>
              </div>
              <div>
                <v-button
                  icon="eye"
                  @click="onViewEndorsementQuote">View Endorsement Quote</v-button>
              </div>
            </div>
            <div
              v-if="isEndorsementBoughtPurchased"
              class="bg-block bg-sky-blue border-left-success">
              <p>This endorsement has been completed.</p>
              <div>
                <v-button
                  icon="eye"
                  @click="goViewPolicy(detailData.relation.endorse_order_id)">View Policy</v-button>
              </div>
              <div>
                <v-button
                  icon="eye"
                  @click="onViewEndorsementQuote">View Endorsement Quote</v-button>
              </div>
              <div>
                <v-button
                  type="success"
                  icon="paper-plane"
                  @click="handlerDeliver">Mark as Issuing</v-button>
              </div>
              <div>
                <v-button
                  type="danger"
                  icon="undo"
                  @click="handlerUndo">Undo Endorsement</v-button>
              </div>
            </div>
            <div
              v-if="isEndorsementRepliedQuote"
              class="bg-block bg-small-blue">
              <p>Quote(s) have been replied in this support ticket.</p>
              <div>
                <v-button
                  icon="money-check-alt"
                  @click="event().onEditEndorsementDraft(0)">Edit Replied Quotes</v-button>
              </div>
              <div>
                <v-button
                  icon="ban"
                  @click="onEndorsementWithDrawQuote">Withdraw Quote</v-button>
              </div>
              <div>
                <v-button
                  type="primary"
                  icon="money-bill-wave"
                  plain
                  @click="onBuyQuote">Buy Quote</v-button>
              </div>
            </div>
            <div
              v-if="isEndorsementDraft"
              class="bg-gray">
              <p>Quote(s) have been saved in this support ticket.</p>
              <v-button
                icon="money-check-alt"
                @click="editDraftCheckTips">Edit Saved Quotes</v-button>
            </div>
          </template>
          <template v-if="type === 6">
            <!-- 下面兩個可以整合成一個，看看接口怎麽寫 -->
            <div
              class="bg-block"
              :class="{
                'bg-sky-blue__radius':claimStatus==1,
                'bg-warning__yellow':claimStatus==0,
                'bg-green__radius':claimStatus==3,
                'bg-red__radius':claimStatus==4,
              }"
            >
              <span class="label">Claim Status</span>
              <p v-if="claimStatus==1">Processing</p>
              <p v-else-if="claimStatus==0">Recieved</p>
              <p v-else-if="claimStatus==3">Settled</p>
              <p v-else-if="claimStatus==4">Rejected</p>
              <v-button
                icon="code-branch"
                green
                class="width-fill"
                @click="handlerDialog('change-claim-status')">Update Status</v-button>
              <v-button
                v-if="![0,1].includes(claimStatus)"
                icon="upload"
                gray
                class="width-fill"
                @click="goViewPolicy(detailData.policy_info.id, 'Claims')">Upload Documents</v-button>
              <v-button
                icon="file-invoice-dollar"
                gray
                class="width-fill"
                @click="handlerDialog('claim-detail-dialog')"
              >Edit Claim Record</v-button>
              <v-button
                icon="list-ul"
                gray
                class="width-fill"
                @click="goViewPolicy(detailData.policy_info.id, 'Claims')"
              >Policy’s All Claim Records</v-button>
            </div>
          </template>
          <!-- <template v-if="type === 4"> -->
          <!-- Reject Transfer -->
          <!-- <div
              v-if="showRejectTransfer"
              class="bg-block bg-danger">
              <p>This transfer request has been rejected.</p>
            </div>
            <div
              v-if="showRemoveQueue"
              class="bg-block bg-sky-blue">
              <p>This transfer request has been added to queue.</p>
              <v-button
                icon="ban"
                @click="event().onRemoveQueue(0)">Remove from Queue</v-button>
            </div>
            <div
              v-if="showDoneTransfer"
              class="bg-block bg-sky-blue">
              <p>This transfer request has been exported from queue.</p>
            </div>
          </template> -->
          <template v-if="type === 7">
            <div
              v-if="isReferralRequestPolicy"
              class="bg-block bg-green">
              <p>A Buyable Quote of this ticket has been purchased.</p>
              <!-- 只有一條，直接拿 business_policy 第一個數據 -->
              <v-button
                icon="eye"
                @click="routerToBusinessPolicy(0)">View Policy</v-button>
            </div>
            <div
              v-if="isReferralRequestQuoted"
              class="bg-block bg-sky-blue">
              <p>This ticket has saved a quote to the customer’s account.</p>
              <v-button
                icon="eye"
                @click="goViewQuote(detailData.relation.order_id)">View Quote</v-button>
            </div>

            <div
              v-if="isReferralRequestReject"
              class="bg-block bg-red">
              <p>This request has been marked as rejected.</p>
            </div>
          </template>

          <div
            v-if="isSmeBusiness && detailData.business_quote && detailData.business_quote.length > 0"
            class="bg-warning">
            <p>Policy has been added.</p>
            <div class="add-policy-list">
              <div
                v-for="(item, index) in detailData.business_quote"
                :key="index"
                class="add-policy-item">
                <span
                  class="bold add-policy-label"
                  @click="routerToBusinessQuote(index)">
                  {{ item.product_language }}
                  <font-awesome-icon
                    class="ic-right"
                    icon="chevron-right"/>
                </span>
                <div>
                  <!-- <span class="bold">HCID</span>
                  {{ item.pcy_id }} -->
                  <span class="bold"> Policy</span>
                  {{ item.pcy_no }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="showPolicyList"
            class="bg-green">
            <p>Policy has been added.</p>

            <div class="add-policy-list">
              <div
                v-for="(item, index) in detailData.business_policy"
                :key="index"
                class="add-policy-item">
                <span
                  class="bold add-policy-label"
                  @click="routerToBusinessPolicy(index)">
                  {{ item.product_language }}
                  <font-awesome-icon
                    class="ic-right"
                    icon="chevron-right"/>
                </span>
                <div>
                  <span class="bold">HCID</span>
                  {{ item.pcy_id }}
                  <span class="bold"> Policy</span>
                  {{ item.pcy_no }}
                </div>
              </div>
            </div>
            <v-button
              icon="plus"
              @click="handlerOnAddPolicy">Add More Policies</v-button>
          </div>

          <!-- type: 4 -->
          <div
            v-if="type == 4"
            class="status-box"
            :class="{
              'yellow-bg': detailData.stts == 1,
              'green-bg': detailData.stts == 2,
              'red-bg': detailData.stts == 3,
              'blue-bg': detailData.stts == 4,
            }">
            <template v-if="detailData.stts == 1">
              <div class="box-title">HD Transfer</div>
              <div class="btn">
                <v-button
                  icon="filter-circle-dollar"
                  class="green-btn"
                  @click="moveTransferQueue">Move To Credit Queue</v-button>
                <v-button
                  icon="ban"
                  class="gray-red-btn"
                  @click="onRejectTransfer">Reject Transfer Request</v-button>
              </div>
            </template>
            <template v-if="detailData.stts == 4">
              <div class="box-title">Added To Queue</div>
              <div class="tips">This transfer request has been move to the queue.</div>
              <div class="btn">
                <v-button
                  icon="ban"
                  class="gray-red-btn"
                  @click="event().onRemoveQueue(0)">Remove From Queue</v-button>
                <!-- <v-button
                  icon="sms"
                  class="gray-black-btn"
                  @click="sendSms">Send Notification SMS</v-button> -->
              </div>
            </template>
            <template v-if="detailData.stts == 2">
              <div class="box-title">Exported From Queue</div>
              <div class="tips">This transfer request has exported from queue.</div>
            </template>
            <template v-if="detailData.stts == 3">
              <div class="box-title">Rejected</div>
              <div class="tips">This transfer request has been rejected.</div>
            </template>
          </div>
          <template v-if="![6,9].includes(type)">
            <template v-if="!isNewSME">
              <div
                v-if="![1,4].includes(type)&&!wainting_sign"
                class="bg-blue">
                <span
                  v-if="type === 2"
                  class="label">Start Refer Case</span>
                <span
                  v-else
                  class="label">Actions & Resolve</span>
                <v-button
                  v-if="type === 2"
                  icon="reply"
                  green
                  :disabled="disabledReplyQuote||!isAttachCustomer"
                  @click="event().handleReplyQuote()">
                  Reply Quote
                </v-button>
                <v-button
                  v-if="type === 2"
                  icon="redo-alt"
                  gray
                  :disabled="!canQuoteAgain"
                  @click="handleQuoteAgain">
                  Quote Again
                </v-button>
                <template v-if="type === 3">
                  <v-button
                    icon="tasks"
                    type="primary"
                    :disabled="disabledBeginEndorsement||isEndorsementUndone"
                    @click="beginEndorsCheckTips">Begin Endorsement</v-button>
                </template>
                <template v-if="type === 5">
                  <v-button
                    type="primary"
                    icon="money-check-alt"
                    :disabled="showPolicyAdded||!isAttachCustomer"
                    @click="handlerOnAddPolicy">Add Policy</v-button>
                </template>
                <!--              <template v-if="type === 6">-->
                <!--                <v-button-->
                <!--                  type="primary"-->
                <!--                  icon="file-invoice-dollar"-->
                <!--                  @click="handlerDialog('claim-detail-dialog')">Edit Policy Claim Info</v-button>-->
                <!--                <v-button-->
                <!--                  type="primary"-->
                <!--                  plain-->
                <!--                  icon="eye"-->
                <!--                  @click="goViewPolicy(detailData.policy_info.id, 'Claims')">View Policy All Claim Info</v-button>-->
                <!--              </template>-->
                <template v-if="type === 7">
                  <v-button
                    v-if="showNewQuote"
                    type="primary"
                    icon="plus"
                    :disabled="disabledNewQuote"
                    @click="onNewQuote">New Quote</v-button>
                  <v-button
                    v-if="!showNewQuote"
                    type="primary"
                    icon="plus"
                    :disabled="disabledReferralReuqestAddPolicyBtn"
                    @click="handlerOnAddPolicy">Add Policy</v-button>
                  <v-button
                    type="primary"
                    icon="user-plus"
                    :disabled="isRegistered"
                    @click="onNewAccount">New Account</v-button>
                  <v-button
                    type="danger"
                    icon="times"
                    :disabled="disabledReferralRequestRejectBtn"
                    @click="onMarkReject">Mark As Reject</v-button>
                </template>
                <!--                      <v-button-->
                <!--                        type="warning"-->
                <!--                        icon="stopwatch"-->
                <!--                        :disabled="disabledSnooze"-->
                <!--                        @click="handlerDialog('snooze-ticket')">-->
                <!--                        Snooze Until-->
                <!--                      </v-button>-->
                <!--                      <v-button-->
                <!--                        type="success"-->
                <!--                        icon="check"-->
                <!--                        :disabled="disabledResolved"-->
                <!--                        @click="handlerDialog('resolve-ticket')">-->
                <!--                        Mark As Resolved-->
                <!--                      </v-button>-->
              </div>
            </template>
            <template v-else>
              <div
                v-if="![1,4].includes(type)&&!wainting_sign&&!disabledReplyQuote"
                class="bg-block  bg-warning__yellow">
                <span
                  class="label">Actions</span>
                <v-button
                  v-if="type === 2"
                  icon="reply"
                  green
                  class="width-fill"
                  :disabled="disabledReplyQuote||!isAttachCustomer"
                  @click="event().handleReplyQuote()">
                  Reply Quote
                </v-button>
              </div>
            </template>
          </template>
          <template v-if="isRenewalTicket">
            <div
              class="bg-yellow"
              :class="{'bg-blue':isRenewQuoteStts&&!isVoidTicket,'bg-red__radius':isVoidTicket}">
              <template v-if="isVoidTicket">
                <span class="flex fs-14 color-del fw-600">
                  <span class="mg-r-3">The ticket has been voided.</span>
                </span>
              </template>
              <template v-else>
                <span class="flex fs-14 color-dark fw-600">
                  <span class="mg-r-3">Renew Status : </span>
                  <span
                    :class="{
                      'blue': relation.stts === 2,
                    }">{{relation.stts_language}}</span>
                </span>
                <p
                  v-if="isRenewQuoteStts"
                  class="fs-14 fw-400 color-dark mg-t-10">Prices have been replied in this support ticket.</p>
                <v-button
                  v-if="[1,2].includes(relation.stts)&&!relation.order_id"
                  green
                  class="mg-t-10"
                  icon="tasks"
                  :disabled="relation.stts==1"
                  @click="addRenewQuote">Begin Renew</v-button>
                <template v-if="relation.order_id&&[2,4].includes(relation.stts)">
                  <v-button
                    gray
                    class="mg-t-10"
                    icon="edit"
                    @click="editRenewQuote(false)">Edit {{relation.stts==4?'Replied':'Save'}} Quotes</v-button>
                </template>
                <v-button
                  v-if="[4].includes(relation.stts)"
                  gray
                  icon="money-check-alt"
                  @click="editRenewQuote(true)">View Replied Quotes</v-button>
                <template v-if="isRenewQuoteStts||isBackToQuoted">
                  <v-button
                    gray
                    class="mg-t-10"
                    icon="edit"
                    @click="editRenewQuote(false)">Edit Replied Quotes</v-button>
                  <v-button
                    green
                    class="mg-t-10"
                    icon="tasks"
                    @click="viewRenewQuote">View Quote</v-button>
                </template>
                <v-button
                  v-if="relation.stts==3"
                  red
                  class="mg-t-10"
                  @click="changeNoNeedRenew(0)"
                >No Need Renew</v-button>
                <v-button
                  v-if="[5].includes(relation.stts)"
                  gray
                  class="mg-t-10"
                  icon="turn-down"
                  @click="changeNoNeedRenew(1)">Back to Quoted</v-button>
                <v-button
                  red
                  class="mg-t-10"
                  @click="handleVoidTicket">Void Ticket</v-button>
              </template>
            </div>
          </template>
          <div class="box">
            <span
              class="label">Tickets</span>


            <!--                                  <span-->
            <!--                                    type="warning"-->
            <!--                                    icon="forward"-->
            <!--                                    :disabled="disabledSnooze"-->
            <!--                                    @click="handlerDialog('snooze-ticket')">-->
            <!--                                    Snooze Until-->
            <!--                                  </span>-->
            <!--                                  <v-button-->
            <!--                                    type="success"-->
            <!--                                    icon="check"-->
            <!--                                    :disabled="disabledResolved"-->
            <!--                                    @click="handlerDialog('resolve-ticket')">-->
            <!--                                    Mark As Resolved-->
            <!--                                  </v-button>-->
            <div class="button-group">
              <span class="flex span-one">
                <font-awesome-icon
                  v-if="status==1"
                  icon="forward"></font-awesome-icon>
                <font-awesome-icon
                  v-if="status==2"
                  icon="check"></font-awesome-icon>
                <font-awesome-icon
                  v-if="status==3"
                  icon="exclamation-circle"></font-awesome-icon>
                <span
                  v-if="status==1"
                  @click="handlerSelectType(2)"> Set Handling</span>
                <span
                  v-if="status==2"
                  @click="handlerSelectType(3)"> Set Resolved</span>
                <span
                  v-if="status==3"
                  @click="handlerSelectType(4)"> Reopen Ticket</span>
              </span>
              <span
                class="span-two flex"
                @click.stop="handlerSetPolicy">
                <span
                  v-if="status==1"
                >New</span>
                <span
                  v-if="status==2"
                >Handling</span>
                <span
                  v-if="status==3"
                >Resolved</span>
                <i class="el-icon-caret-bottom"></i>
              </span>

            </div>
            <ul
              v-if="setPolicy"
              class="setting-menu">
              <li @click="handlerSelectType(1)">
                <div class="with-icon">
                  <i
                    v-show="status==1"
                    class="el-icon-check"></i>
                </div>
                <span>New</span>
              </li>
              <li @click="handlerSelectType(2)">
                <div class="with-icon">
                  <i
                    v-show="status==2"
                    class="el-icon-check"></i>
                </div>
                <span>Handling</span>
              </li>
              <li @click="handlerSelectType(3)">
                <div  class="with-icon">
                  <i
                    v-show="status==3"
                    class="el-icon-check"></i>
                </div>
                <span>Resolved</span>
              </li>
            </ul>

            <div
              class="button-width">
              <v-button
                icon="stopwatch"
                class="button-weight"
                :class="{'is_snooze':is_snooze==1}"
                :disabled="disabledSnooze"
                @click="handlerDialog('snooze-ticket')">
                {{is_snooze==1?`Snoozed til ${showHKTime(detailData.snooze_until)}`:'Snooze'}}
              </v-button>
            </div>
          </div>
          <div
            v-if="type === 1"
            class="box">
            <span class="label">Change Ticket Category</span>
            <v-select
              v-model="changeCategory"
              :list="changeTicketCategoryOpitons"
              @change="handlerChangeCategory" />
          </div>
          <!--          <div-->
          <!--            v-if="type === 3"-->
          <!--            class="box">-->
          <!--            <v-button-->
          <!--              :disabled="disabledEndorsementMock"-->
          <!--              icon="calculator"-->
          <!--              @click="mockCalculate">Mock Calculate Price</v-button>-->
          <!--          </div>-->
          <!-- 這裏應該都是一樣的 -->
          <!--          <div class="box">-->
          <!--            <span class="label">Customer Support</span>-->
          <!--            <v-button-->
          <!--              type="primary"-->
          <!--              icon="sticky-note"-->
          <!--              @click="handlerDialog('add-mark')">-->
          <!--              Add Remark-->
          <!--            </v-button>-->
          <!--            <v-button-->
          <!--              v-if="type !== 5"-->
          <!--              icon="comments"-->
          <!--              type="primary">-->
          <!--              Message Insurer-->
          <!--            </v-button>-->
          <!--          </div>-->
          <div>
            <right-customer-detail
              v-if="!isGuestTravel"
              :detail-data="detailData"
              can-customer-add
              :show-customer="customerId>0"
              is-edit
              :is-fina="isFina"
              is-ticket
              :is-share="false"
              has-original
              :customer-profile="customer_profile"
              @view="viewCustomer"
              @editDes="editDescription"
              @success="handler().getUpdateDetailData(0)"
              @attach="editCustomer">
            </right-customer-detail>
            <div
              v-if="referDetail.is_share_guest_order&&hasShareInitiator"
              class="box">
              <div class="flex flex-sb">
                <span class="title">Share Initiator</span>
              </div>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{ shareInitiator.identity==2?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:shareInitiator.id}}"
                    class="flex flex-wrap">
                    <span
                      v-if="shareInitiator.isrd_nm"
                      class="plan-name hand"
                      @click="viewCustomer()">{{ shareInitiator.isrd_nm }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                      @click="viewCustomer()">Unnamed Account &nbsp;</span>
                    <span
                      v-if="shareInitiator.identity!==2&& shareInitiator.nick_name"
                      class="plan-name small hand"
                      @click="viewCustomer()">({{ shareInitiator.nick_name }})</span>
                  </router-link>


                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ shareInitiator.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ shareInitiator.polices }}</span>
                  </li>
                </ul>
              </div>
              <div class="box-show">
                <div class="flex flex-sb">
                  <span class="title">Share Information</span>
                </div>
                <ul class="margin-top-none">
                  <li>
                    <span>Self-described Name</span>
                    <span>{{ referDetail.share_referral_nm }}</span>
                  </li>
                </ul>
              </div>
              <contact-customer
                :customerId="shareInitiator.id"
                :phone="shareInitiator.phone"
                :customerName="shareInitiator.isrd_nm"
                :email="shareInitiator.send_email"
                @success="handler().getUpdateDetailData(0)"
              />
            </div>
            <!--            <div-->
            <!--              v-else-->
            <!--              class="box">-->
            <!--              <div-->
            <!--                class="button-width">-->
            <!--                <v-button-->
            <!--                  icon="plus"-->
            <!--                  class="button-weight"-->
            <!--                  @click="editCustomer">Attach Customer-->
            <!--                </v-button>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>

          <div   v-if="type === 7">
            <div
              v-if="detailData.relation.client_profile"
              class="box">
              <div class="flex flex-sb">
                <span class="title">Client Profile</span>
                <span
                  class="blue hand"
                  @click="editCustomer('client')">Edit</span>
              </div>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <!--                  <span class="span-status">{{detailData.id_type==3?'Company':'Personal'}}</span>-->
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customerType('client')}}"
                    class="flex flex-wrap">
                    <span
                      class="plan-name hand"
                      @click="viewCustomer('client')">{{ detailData.relation.client_profile.isrd_nm }} &nbsp;</span>
                  </router-link>
                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ detailData.relation.client_profile.created_at}}</span>
                  </li>
                  <li>
                    <span>Policies</span>
                    <span>{{ detailData.relation.client_profile.polices }} Active</span>
                  </li>
                </ul>
              </div>
            <!--              <contact-customer-->
            <!--                :customerId="detailData.customer_id"-->
            <!--                :phone="detailData.phone"-->
            <!--                :customerName="detailData.customer.isrd_nm"-->
            <!--                :email="detailData.send_email"-->
            <!--                @success="handler().getUpdateDetailData(0)"-->
            <!--              />-->
            </div>
            <div
              v-else
              class="box">
              <div
                class="button-width">
                <v-button
                  icon="plus"
                  class="button-weight"
                  @click="viewCustomer('client')">Attach Customer
                </v-button>
              </div>
            </div>
          </div>
          <!--          <div-->
          <!--            v-if="type === 1"-->
          <!--            class="box">-->
          <!--            <span class="label">Change Ticket Category</span>-->
          <!--            <v-select-->
          <!--              v-model="changeCategory"-->
          <!--              :list="changeTicketCategoryOpitons"-->
          <!--              @change="handlerChangeCategory" />-->
          <!--          </div>-->
          <!--          <div-->
          <!--            v-if="type === 3"-->
          <!--            class="box">-->
          <!--            <v-button-->
          <!--              :disabled="disabledEndorsementMock"-->
          <!--              icon="calculator"-->
          <!--              @click="mockCalculate">Mock Calculate Price</v-button>-->
          <!--          </div>-->
          <div
            v-if="showPolicyInfo"
            class="box">
            <div class="flex flex-sb">
              <span class="title">Policy Info</span>
              <span
                class="blue hand"
                @click="openDialog('attach-policy')">{{detailData.policy_info?'Edit':'Add'}}</span>
            </div>
            <div  v-if="detailData.policy_info">
              <div

                class="flex ">
                <div class="flex-icon">
                  <span class="icon-width">
                    <span
                      v-if="detailData.policy_info.company_id !== 0"
                      v-tooltip="detailData.policy_info.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', detailData.policy_info.company_id).logo? getOptionData('companySmallIcon', detailData.policy_info.company_id).logo: detailData.policy_info.company_icon"
                      >
                    </span>
                  </span>
                  <span class="icon-width icon-margin-top">
                    <span
                      v-tooltip="detailData.policy_info.class_language"
                      class="icon icon-content "
                    >
                      <font-awesome-icon
                        v-if="detailData.policy_info.class_id"
                        :icon="getOptionName('iconOptions', detailData.policy_info.class_id)" />
                    </span>
                  </span>
                </div>

                <router-link
                  v-if="detailData.policy_info.product_id>=90"
                  :to="{path:'/records/micropolicy/detail',query:{
                    id: detailData.policy_info.id,
                    pcy_id:detailData.policy_info.pcy_id,
                    product_id: detailData.policy_info.product_id}}"
                  class="plan-name">
                  {{ detailData.policy_info.plan }}
                  {{ detailData.policy_info.pcy_class }}
                  <br />{{ detailData.policy_info.trm_of_cvr_language }}
                  <!--                  <br />Plan-->
                </router-link>
                <router-link
                  v-else
                  :to="{path:'/records/policy/detail',query:{
                    id: detailData.policy_info.id,
                    pcy_id:detailData.policy_info.pcy_id,
                    product_id: detailData.policy_info.product_id}}"
                  class="plan-name">
                  {{ detailData.policy_info.plan }}
                  {{ detailData.policy_info.pcy_class }}
                  <br />{{ detailData.policy_info.trm_of_cvr_language }}
                  <!--                  <br />Plan-->
                </router-link>
              </div>
              <ul>
                <li>
                  <span>Issue Date</span>
                  <span>{{ detailData.policy_info.issue_dt  }}</span>
                </li>
                <li>
                  <span>Policy No.</span>
                  <span>{{ detailData.policy_info.pcy_no }}</span>
                </li>
                <li>
                  <span>Policy Period</span>
                  <span>{{ detailData.policy_info.period_start }} - {{ detailData.policy_info.period_end }}</span>
                </li>
                <li>
                  <span>Status</span>
                  <span
                    class="policy-span-status"
                    :class="{
                      'orange': [401, 301].includes(detailData.policy_info.pcy_stts),
                      'yellow-dark': detailData.policy_info.pcy_stts == 410,
                      'blue': [420, 505, 705].includes(detailData.policy_info.pcy_stts),
                      'green': [425, 501, 510, 701].includes(detailData.policy_info.pcy_stts),
                      'red': [801, 0].includes(detailData.policy_info.pcy_stts),
                      'purple': [710].includes(detailData.policy_info.pcy_stts),
                    }">{{ detailData.policy_info.pcy_stts_language }}</span>
                </li>
                <li>
                  <span>Account</span>
                  <span><i :class="detailData.policy_info.customer_id>0?'el-icon-user-solid':'el-icon-user'"/> {{ detailData.policy_info.customer_id>0?'Having an Account':'Without account' }}</span>
                </li>
              </ul>
            </div>
            <template v-else>
              <span class="unname none-data">No policy attached</span>
            </template>
          </div>
          <!--          <div-->
          <!--            v-if="!detailData.policy_info && showPolicyInfoEdit"-->
          <!--            class="box">-->
          <!--            <div-->
          <!--              class="button-width">-->
          <!--              <v-button-->
          <!--                icon="plus"-->
          <!--                class="button-weight"-->
          <!--                @click="openDialog('attach-policy')">Attach Policy</v-button>-->
          <!--            </div>-->
          <!--          </div>-->
          <div
            v-if="showQuoteInfo"
            class="box">
            <div class="flex flex-sb">
              <span class="title">Quote Info</span>
              <span
                class="blue hand"
                @click="openDialog('attach-quote')">{{detailData.quote_info?'Edit':'Attach'}}</span>
            </div>
            <template  v-if="detailData.quote_info">
              <div
                class="flex ">
                <div class="flex-icon">
                  <span class="icon-width">
                    <span
                      v-if="detailData.quote_info.company_id !== 0"
                      v-tooltip="detailData.quote_info.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', detailData.quote_info.company_id).logo? getOptionData('companySmallIcon', detailData.quote_info.company_id).logo: detailData.quote_info.company_icon"
                      >
                    </span>
                  </span>
                  <span class="icon-width icon-margin-top">
                    <span
                      v-tooltip="detailData.quote_info.class_language"
                      class="icon icon-content "
                    >
                      <font-awesome-icon
                        v-if="detailData.quote_info.class_id"
                        :icon="getOptionName('iconOptions', detailData.quote_info.class_id)" />
                    </span>
                  </span>
                </div>
                <router-link
                  :to="{path:'/records/quote/detail',query:{order_id: detailData.quote_info.id,
                                                            product_id: detailData.quote_info.product_id}}"
                  class="plan-name">
                  {{ detailData.quote_info.pcy_class }}
                  <!-- {{ detailData.quote_info.product_language }} Insurance -->
                  <br />{{ detailData.quote_info.plan }}
                <!--                  <br />Plan-->
                </router-link>
              </div>
              <ul>
                <li>
                  <span>Created</span>
                  <span>{{ detailData.quote_info.created_at  }}</span>
                </li>
                <li>
                  <span>Quote No.</span>
                  <span>{{ detailData.quote_info.quotation_number}}</span>
                </li>
                <li>
                  <span>Policy Period</span>
                  <span>{{ detailData.quote_info.period_start }} -{{ detailData.quote_info.period_end }}</span>
                </li>
                <li>
                  <span>Total Payable</span>
                  <span>${{ detailData.quote_info.amount }}</span>
                </li>
              </ul>
            </template>
            <template v-else>
              <span class="unname none-data">No quote attached</span>
            </template>
          </div>
          <!--          <div-->
          <!--            v-if="!detailData.quote_info"-->
          <!--            class="box">-->
          <!--            <div-->
          <!--              class="button-width">-->
          <!--              <v-button-->
          <!--                icon="plus"-->
          <!--                class="button-weight"-->
          <!--                @click="openDialog('attach-quote')">Attach Quote</v-button>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="box">
            <div class="flex flex-sb">
              <span class="title">Related Ticket</span>
              <span
                class="blue hand"
                @click="event().onAttatchTicket(0)">{{ticketSelectArr.length>0?'Edit':'Add'}}</span>
            </div>
            <template v-if="ticketSelectArr.length>0">
              <router-link
                v-for="(item, index) in ticketSelectArr"
                :key="index"
                class="tr pointer tr-margin tr-a"
                :to="{path:'/tickets/detail',query:{ticket_id:item.id}}"
                @click="viewTicket(item.id)">
                <span>
                  <span class="span-status">{{ item.type_language }}</span>
                </span>
                <span class="blue">{{ item.subject }}</span>
              </router-link>
            </template>
            <template v-else>
              <span class="unname none-data">No related tickets</span>
            </template>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkLogsData"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.agent }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @keyEnter="handlerSendRemark"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!showMain||showMainRight"
        class="main-edit">
        <section
          v-show="showMainRight"
        >
          <section v-if="type === 3">
            <section v-if="showEndorsementQuoteInfo">
              <view-endorsement-quote
                :form="endorsmentForm"
                :ticketId="ticketId"
                :orderId="detailData.relation.order_id"
                :oldForm="endorsementQuote.previous_data"
                :action="detailData.relation.action"
                @back="closeMainRightEndorsement" />
            </section>
            <section v-if="showMockCalculate">
              <mock-calculate
                :form="policyData"
                :ticketId="ticketId"
                :orderId="detailData.relation.order_id"
                @close="closeMockCalculate" />
            </section>
          </section>
          <section v-if="type === 4">
            <move-transfer-queue
              ref="move-transfer-queue"
              :form="detailData.relation"
              :remarkDetail="remarkDetail"
              @cancel="cancelRightEdit"
              @sendRemark="handlerSendRemark"
              @success="handler().initStatusUpdateData(0)"   />
          </section>
        </section>
        <section v-if="showEdit">
          <edit-refer-case
            v-if="showEditType === 2"
            :form="referData"
            :editType="referEditType"
            :checkRefer="checkRefer"
            :isShowQuick="isShowQuick"
            :is-fina="isFina"
            :customerId="customerId"
            :show-buyable="showBuyable"
            @save-success="handlerSave"
            @save-draft="handlerSave"
            @reply-all="handlerSave"
            @reply-complete="handlerSave"
            @cancel="cancelEdit" />
          <edit-endorsement
            v-if="showEditType === 3"
            :changeCategoryType="changeCategory"
            :form="detailData.relation"
            :customerId="customerId"
            :ticketId="ticketId"
            :is-fina="isFina"
            @cancel="cancelEdit"
            @save="saveChangeCategory" />
          <edit-credit-transfer
            v-if="showEditType === 4"
            :changeCategoryType="changeCategory"
            :form="detailData.relation"
            :ticketId="ticketId"
            :is-fina="isFina"
            :customerId="customerId"
            :referrer-id="detailData.referrer_id"
            @cancel="cancelEdit"
            @save="saveChangeCategory" />
          <edit-business
            v-if="showEditType === 5"
            :changeCategoryType="changeCategory"
            :form="detailData.relation"
            :ticketId="ticketId"
            :is-fina="isFina"
            :customerId="customerId"
            @cancel="cancelEdit"
            @save="handlerSave"/>
          <template v-if="showEditType ===6">
            <edit-claim
              v-if="showEidtClaim==0"
              :form="detailData.relation"
              :ticketId="ticketId"
              :detailData="policyData"
              :customerId="customerId"
              @cancel="cancelEdit"
              @refresh="handleRefresh"
              @save="handlerSave" />
            <edit-claim-status
              v-else
              ref="edit-claim-status"
              :claimStatus="detailData.relation.status"
              :renewOrderSn="renew_order_sn"
              :claimId="detailData.relation.id"
              :detailData="policyData"
              :is-fina="isFina"
              :relation="relation"
              :form="editClaimData"
              :customers="detailData.customer"
              @success="changeClaimStatus"
              @nextStep="nextStep"
              @refresh="handleRefresh"
              @cancel="cancelEdit"></edit-claim-status>
          </template>

          <edit-referral-request
            v-if="showEditType === 7"
            :form="detailData.relation"
            :referralRequestId="detailData.relation.id"
            @cancel="cancelEdit"
            @save="handlerSave" />
          <edit-internal-doc
            v-if="isRenewalTicket"
            :form="detailData"
            @success="handleUpdateDetail"
            @update="updateTicketDetail"
            @cancel="handleCancel"></edit-internal-doc>
        </section>
        <div
          v-if="showKyc"
          class="other-body">
          <edit-kyc
            ref="edit-kyc"
            :hasEndorsNum="hasEndorsNum"
            :hasClaimNum="unsettled_claims && unsettled_claims.length > 0"
            :editType="3"
            :is-fina="isFina"
            :customerId="customerId"
            is-renewal-ticket
            :form="renewKycDetail"
            :show-buyable="isViewRenew"
            :fromEdit="fromEdit"
            :relation="relation"
            @update="handleUpdateRenewalDetail"
            @nextStep="nextRenewalStep"
            @reply-all="handlerRenewalSave"
            @cancel="cancelRenewalEdit"></edit-kyc>
        </div>
        <section v-if="showBuyQuoteContainer">
          <buy-quote-container
            v-if="type === 2"
            :referDetail="referDetail"
            :orderId="detailData.relation.order_id"
            :is-refer="true"
            :is-fina="isFina"
            :customerId="detailData.customer_id"
            @back="handler().initStatusUpdateData(0)"  />
          <endorse-payment
            v-if="type === 3"
            :is-fina="isFina"
            :orderId="detailData.relation.endorse_order_id"
            :policyModifyId="detailData.relation.id"
            :form="policyData" />
        </section>

        <section v-show="showOther">
          <add-quote
            v-if="showAddQuote"
            ref="add-quote"
            :quoteId="detailData.relation.id"
            :type="2"
            :relation="detailData.relation"
            :customerId="detailData.customer_id"
            :isReferralRequest="type == 7"
            :referralRequestId="detailData.relation.id"
            :quoteOrderId="businessPolicyOrderId"
            @cancel="cancelOther"
            @save="handler().initStatusUpdateData(0)"
            @create-success="handlerCreatePolicySuccess" />
          <policy-added
            v-if="showPolicyAddedPage"
            :detail="detailData"
            @cancel="cancelOther" />

          <new-quote
            v-if="showNewQuotePage"
            :relation="detailData.relation"
            @back="handlerNewQuoteBack"
            @success="handlerNewQuoteSuccess" />

          <create-account
            v-if="showCreateAccount"
            :isReferralRequest="type === 7"
            :relation="detailData.relation"
            :referralRequestId="detailData.relation.id"
            @back="handlerCreateAccountBack"
            @success="handlerCreateAccountSuccess" />

          <business-payment
            v-if="showBusinessPayment"
            :orderId="businessPolicyOrderId"
            :customer="detailData.customer"
            :customerId="detailData.customer_id"
            @cancel="handlerBusinessPaymentCancel"
            @business-payment-success="handlerBusinessPaymentSuccess" />


        </section>
      </div>
    </div>

    <to-top
      v-if="!showMain||showMainRight"
      :el='container'></to-top>

    <!-- dialog -->
    <snooze-ticket
      ref="snooze-ticket"
      :ticketId="ticketId"
      :form="detailData"
      @success="handler().getUpdateDetailData(0)" />
    <resolve-ticket
      ref="resolve-ticket"
      :ticketId="ticketId"
      @success="handler().getUpdateDetailData(0)" />
    <add-remark
      ref="add-mark"
      @confirm="handlerAddRemark" />
    <contact-dialog
      ref="contact-dialog"
      :ticketId="ticketId"
      :initCustomerId="detailData.customer_id"
      :initPhone="referDetail.mobile_no||referDetail.contact_phone"
      :initEmail="referDetail.email"
      :customerData="customerData"
      :shareLink="initContent"
      is-refer-ticket
      :is-input="showBuyable"
      :is-refer-buyable="showBuyable"
      :refer-id="referId"
      :type="contactType" />
    <attach-user
      ref="attach-user"
      :ticketId="ticketId"
      @success="handler().getUpdateDetailData(0)" />

    <attach-user
      ref="attach-user-client"
      :ticketId="ticketId"
      :isReferralRequest="type == 7"
      :referralRequestId="detailData.relation.id"
      @success="handler().getUpdateDetailData(0)" />


    <attach-policy
      ref="attach-policy"
      :ticketId="ticketId"
      :customerId="customerId"
      :policyId="detailData.policy_info? detailData.policy_info.id: ''"
      @success="handler().getUpdateDetailData(0)" />
    <attach-quote
      ref="attach-quote"
      :ticketId="ticketId"
      :customerId="customerId"
      @success="handler().getUpdateDetailData(0)" />

    <related-tickets
      ref="related-tickets"
      :ticketId="ticketId"
      :referTickList="ticketSelectArr"
      @success="handler().getUpdateDetailData(0)" />

    <undo-endorsement
      :id="detailData.relation.id"
      ref="undo-endorsement"
      :dialogType="undoEndorsementType"
      @done="handler().getUpdateDetailData(0)" />
    <the-refund ref="the-refund" />
    <transfer-funds ref="transfer-funds" />
    <mark-sent-insurer
      :id="detailData.relation.id"
      ref="mark-sent-insurer"
      @done="handler().getUpdateDetailData(0)" />

    <claim-detail-dialog
      ref="claim-detail-dialog"
      :form="claimDetailData" />
    <change-claim-status
      ref="change-claim-status"
      :claimStatus="detailData.relation.status"
      :renewOrderSn="renew_order_sn"
      :claimId="detailData.relation.id"
      :detailData="policyData"
      :is-fina="isFina"
      :relation="relation"
      :customers="detailData.customer"
      @nextStep="nextStep"
      @update="handleUpdateDetail"
      @success="changeClaimStatus" />
    <set-void-quote
      ref="set-void-quote"
      :orderId="orderId"
      :refund="detailData.amount"
      :is-normal="false"
      :type="1"
      @setVoid="handlerVoid"></set-void-quote>

    <mark-as-endorsed
      :id="detailData.relation.id"
      ref="mark-as-endorsed-dialog"
      :detail="policyData"
      :isCancel="isCancel"
      @success="handler().getUpdateDetailData(0)" />

    <send-email-sms
      ref="send-email-sms"
      :form="referDetail"
      :skip="false"
      :initContent="detailData.relation.refer_ready_url_data"
      @send="handlerReferralSmsSend" />
    <send-email-sms
      ref="send-fina-email-sms"
      :form="customer_profile"
      :type="1"
      :is-fina="isFina"
      :is-only-referrer="isFina"
      :skip="true"
      :emailListTitle="detailData.relation.reject_email_list_title"
      :emailTitle="detailData.relation.reject_list_title"
      :initContent="detailData.relation.reject_url_data"
      :init-refer-content="detailData.relation.reject_url_data"
      @send="handlerRejectTranfer"
      @skip="handlerEmailSmsSkip"
    />
    <reply-quote
      ref="reply-quote"
      @buyable="onUpgradeQuoteClick"
      @priceOnly="event().onReplyQuote()"></reply-quote>

    <download-pdf
      ref="download-pdf"
      :quotation-pdf="quotation_pdf"
      :list="referDetail.reference_pdf_download_lists"></download-pdf>

    <endors-renew-tips
      ref="renew-tips"
      :stts="renewStts"
      :renewOrderSn="renew_order_sn"
      @continue="tipsContinue"></endors-renew-tips>
    <edit-description
      ref="edit-description"
      :detailData="customer_profile"
      :customerId="customerId"
      @update="getUpdateAccountData"></edit-description>
    <endors-renew-tips
      ref="claim-tips"
      :cliams="unsettled_claims"
      @continue="tipsRenewalContinue"></endors-renew-tips>
    <endors-renew-tips
      ref="endors-tips"
      :endorse-number="endorsement_ticket_number"
      :endorse-order-id="endorsement_order_id"
      is-endorsement
      @continue="tipsRenewalContinue"></endors-renew-tips>
    <select-send-message
      v-model="showAutoCloseSelectMessage"
      :form="renew_send_data"
      :initSmsContent="auto_renew_close_data"
      :init-email-content="email_auto_renew_close_data"
      :init-share-content="share_auto_renew_close_data"
      :is-only-referrer="isFina"
      :updateContent="true"
      @send="handlerRenewSend"
      @skip="handlerRenewSkip"></select-send-message>
    <!-- <send-email-sms
      ref="send-email-sms-transfer"
      :form="detailData.customer"
      :initContent="detailData.relation.url_data"
      :emailListTitle="detailData.relation.url_list_title"
      :emailTitle="detailData.relation.url_title"
      @skip="handlerSkipTransfer"
      @send="handlerSendTransfer" /> -->

  </section>
</template>
<script>
import SupportLog from './components/support-log'
import InternalDocument from '@/views/components/internal-document'
import DocumentInfo from './components/document-info'
import RequestDetail from './components/request-detail'
import SnoozeTicket from './dialogs/snooze-ticket.vue'
import ResolveTicket from './dialogs/resolve-ticket'
import AddRemark from './dialogs/add-remark'
import ContactDialog from './dialogs/new-contact-dialog'
import AttachUser from './dialogs/attach-user'
import AttachPolicy from './dialogs/attach-policy'
import AttachQuote from './dialogs/attach-quote'
import RelatedTickets from './dialogs/related-tickets'
import setVoidQuote from '@/views/components/set-void-quote'
// import EditRefer from './components/edit-refer'
// import ReplyRefer from './components/reply-refer'
import EditBusiness from './components/edit-business'
import EditEndorsement from './components/edit-endorsement'
import EditCreditTransfer from './components/edit-credit-transfer'
import EditReferCase from './components/edit-refer-case'
import EditClaim from './components/edit-claim'
import EditReferralRequest from './components/edit-referral-request'
import BuyQuoteContainer from './components/buy-quote'
import ContactCustomer from '@/views/components/new-contact-customer'
import ReplyQuote from './dialogs/reply-quote'
import {
  addTicketRemark,
  getTicketDetail,
  getTicketRemark,
  reopenTicket,
  setResolvedTicket,
  setTicketCs,
  setTicketUnsnooze,
} from '@/api/ticket'
import {getAccountDetail} from '@/api/account'
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinSendSMSEmail from '@/mixins/sendSMSEmail'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {
  changeReferralStts,
  getCoressReferDetail,
  sendReferralSms,
} from '@/api/refer'
import {
  getPolicyDetail
} from '@/api/policy'
import {
  changeEndorsementStatus,
  getEndorsementQuoteView,
  sendEndorsementInsurer,
  undoEndorsement
} from '@/api/endorsement'
import {rejectCreditTransfer, removeCreditTransfer} from '@/api/credits'
import {rejectReferralRequest} from '@/api/request'
import {getSMEReferDetail} from '@/api/sme'

import AddQuote from './components/add-quote'
import EditPolicy from './components/edit-policy'
import UndoEndorsement from './dialogs/undo-endorsement'
import TheRefund from './dialogs/refund'
import TransferFunds from './dialogs/transfer-funds'
import ClaimDetailDialog from '@/views/records/policy/components/dialog/claim-detail-dialog'
import ChangeClaimStatus from './dialogs/change-claim-status'
import MoveTransferQueue from './components/move-transfer-queue'
import MarkSentInsurer from './dialogs/mark-sent-insurer'
import ViewEndorsementQuote from './components/view-endorsement-quote'
import MockCalculate from './components/mock-calculate'
import EndorsePayment from './components/endorse-payment'
import RejectRequest from './dialogs/reject-request'
import PolicyAdded from './components/policy-added'
import NewQuote from './components/new-quote'
import CreateAccount from '@/views/accounts/create'
import BusinessPayment from './components/business-payment'
import MarkAsEndorsed from './dialogs/mark-as-endorsed'
import DownloadPdf from './dialogs/download-pdf'
import endorsRenewTips from '@/views/components/dialogs/endors-renew-tips'
import {productAPiPath} from '@/utils/smePath'
import {getQuoteUrl, orderSkip} from '@/api/quote'
import BlockWarning from '@/views/components/block-warning'
import EditDescription from '@/views/accounts/dialog/edit-description'
import CauseList from '@/views/tickets/components/cause-list'
import {newSMEPolicyDetail} from '@api/new_sme'
import EditClaimStatus from './components/edit-claim-status'
import RightCustomerDetail from '@/views/components/right-customer-detail'
import rightCustomerDetail from '@/views/components/right-customer-detail'
import RenewTicketDetail from '@/views/renew/components/renew-ticket-detail'
import MixinRenewTicket from '@/mixins/renew-ticket'
import {voidRenewalTicket} from '@api/renewal'
export default {
  name: 'Detail',
  components: {
    RenewTicketDetail,
    RightCustomerDetail,
    CauseList,
    SupportLog,
    InternalDocument,
    RequestDetail,
    DocumentInfo,
    SnoozeTicket,
    ResolveTicket,
    AddRemark,
    ContactDialog,
    AttachUser,
    AttachPolicy,
    AttachQuote,
    RelatedTickets,
    // EditRefer,
    // ReplyRefer,
    EditBusiness,
    EditEndorsement,
    EditCreditTransfer,
    EditReferCase,
    EditClaim,
    EditReferralRequest,
    BuyQuoteContainer,
    ContactCustomer,
    AddQuote,
    UndoEndorsement,
    TheRefund,
    TransferFunds,
    ClaimDetailDialog,
    ChangeClaimStatus,
    MoveTransferQueue,
    MarkSentInsurer,
    ViewEndorsementQuote,
    MockCalculate,
    EndorsePayment,
    PolicyAdded,
    NewQuote,
    CreateAccount,
    setVoidQuote,
    BusinessPayment,
    MarkAsEndorsed,
    SendEmailSms,
    ReplyQuote,
    DownloadPdf,
    endorsRenewTips,
    // attachCustomer
    BlockWarning,
    EditDescription,
    EditClaimStatus,
    rightCustomerDetail,
  },
  mixins: [MixinOptions,MixinSendSMSEmail,MixinRenewTicket],
  data() {
    return {
      loading: false,
      initContent: '',
      way: '',
      container: null,
      isUndo:false,
      // showMain: true,
      isBeginEndorsement: false, // 標記是 Begin Endorsement，需要清空 Detail Change 和 remark
      showEdit: false,
      showEidtClaim: 0,
      showBuyQuoteContainer: false,
      showPolicyAddedPage: false,
      showAddQuote: false,
      showNewQuotePage: false,
      showCreateAccount: false,
      showBusinessPayment: false,
      // showReply: false,
      showOther: false,
      referEdit: false,
      businessEdit: false,
      referEditType: 0,
      isShowQuick:0,//edit request、edit 0 ，1 reply
      checkRefer:0,//0正常，1是refer 草稿（不用验证），2是编辑确认
      businessAddQuoteType: 1, // 1 - add quote, 2 - add policy
      typeList: [
        {
          type: 1,
          name: 'General'
        },
        {
          type: 2,
          name: 'Refer Case'
        },
        {
          type: 3,
          name: 'Endorsement'
        },
        {
          type: 4,
          name: 'Credit transfer'
        },
        {
          type: 5,
          name: 'Business'
        },
        {
          type: 6,
          name: 'Claims'
        },
      ],
      setPolicy:false,
      policyType:1,
      // type: 1, // 1-General 一般 2-refer case 人工单 3-endorsement 改单
      // 4-credit transfer 奖励金？？？ 5-business 商用 6-Claims 索偿
      supportLogType: 0, // support logs 組件 type
      // supportLogsData: [], // logs 數據
      // status: 0,
      showMainRight: false,
      showBeginEndorsement: false,
      showEndorsementQuoteInfo: false,
      showMockCalculate: false,
      editStatus: false,
      contactType: 0,
      activeTab: '1',
      remarkDetail:{},
      referTab: [
        {
          label: 'Request Detail',
          name: '1'
        },
        {
          label: 'Document',
          name: '2'
        },
        {
          label: 'Cause',
          name: '5'
        },
        {
          label: 'Internal Document',
          name: '4'
        },
        {
          label: 'Support Log',
          name: '3'
        },
      ],
      businessTab: [
        {
          label: 'Request Detail',
          name: '1'
        },
        {
          label: 'Internal Document',
          name: '2'
        },
        {
          label: 'Support Log',
          name: '3'
        }
      ],
      generalTab: [
        {
          label: 'Support Log',
          name: '1'
        },
        {
          label: 'Internal Document',
          name: '2'
        },

      ],
      claimTab: [
        {
          label: 'Request Detail',
          name: '1'
        },
        {
          label: 'Support Log',
          name: '2'
        },

      ],
      // data
      detailData: {
        relation: {
          client_profile: null
        },
        status_record:[]
      },
      referDetail: {},
      policyData: {},
      endorsePolicyData: {},
      changeCategory: '', // general 改成 其他 類型
      changeTicketCategoryOpitons: [
        {
          name: 'Business',
          id: 5
        },
        // {
        //   name: 'Endorsement',
        //   id: 3
        // },
        {
          name: 'Credit Transfer',
          id: 4
        }
      ],
      assignee: '',
      endorsementQuote: {
        previous_data: {},
        new_data: {}
      },
      undoEndorsementType: 0,
      // 狀態
      // isEditEndorsementDraft: false
      relationForm: {},
      businessPolicyOrderId: '',
      customer_profile:{},
      message:'',
      renew_order_sn: '',
      step: 0,
      renewStts: 0,
      quoteUrl: '',
      editClaimData:{}
    }
  },
  computed: {
    ...mapState('common', ['globalOptions']),
    ...mapState('ticket', ['ticketData', 'referData', 'refreshPage']),
    endorsmentForm(){
      let {new_data,clawback} = this.endorsementQuote||{}
      return{
        ...new_data,
        clawback:clawback
      }
    },
    merchant_platform(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform
    },
    isFina(){
      return this.merchant_platform == 2
    },
    customer_description(){
      let str = this.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    shareInitiator(){
      return this.referDetail.share_initiator
    },
    hasShareInitiator(){
      let is_share = JSON.stringify(this.shareInitiator)
      return is_share!='[]'&&is_share!='{}'
    },
    showPdf(){
      // if(this.referDetail.reference_pdf_download_lists){
      //   return this.referDetail.reference_pdf_download_lists.length > 0
      // }、
      let {stts} = this.detailData||{}
      let {quotation_pdf={}} = this.referDetail||{}
      let {id} = quotation_pdf||{}
      return id&&stts!=2?true:false
    },
    quotation_pdf(){
      let {quotation_pdf={}} = this.referDetail||{}
      return quotation_pdf||{}
    },
    avt_pic(){
      const {avatar_pic={}} = this.detailData.customer||{}
      return avatar_pic&&avatar_pic.url||''
    },
    isCancel() {
      const { action } = this.relation
      return action != 1
    },
    relation() {
      const { relation } = this.detailData
      return relation || {}
    },
    status_record() {
      const { status_record } = this.detailData
      return status_record || []
    },
    contact_data(){
      const { contact_data } = this.detailData
      return contact_data || {}
    },
    productId() {
      return this.detailData.relation.product_id
    },
    // 1-General 2-refer case 3-endorsement 4-credit transfer 5-business 6-Claims
    type() {
      // return 2 // 測試
      return this.detailData.type
    },
    isRenewalTicket(){
      return this.type==9
    },
    wainting_sign() {
      let {stts} = this.detailData||{}
      return stts == 5
    },
    // 控制 edit 顯示的是 change category 的還是 其他 edit 狀態
    showEditType() {
      return this.changeCategory !== ''? this.changeCategory: this.type
    },
    // 控制左邊 policy 和 quote info
    showPolicyInfo() {
      return [1, 3, 6,9].includes(this.type)
    },
    showPolicyInfoEdit() {
      return [1].includes(this.type)
    },
    showQuoteInfo() {
      return [1].includes(this.type)
    },
    // 1-Open 2-Snooze 3-Resolved
    status() {
      return this.detailData.status || 1 // 優化 resolved
    },
    is_snooze() {
      return this.detailData.is_snooze// 優化 resolved
    },
    ticketId() {
      let {ticket_id} =this.$route.query||{}
      return ticket_id
    },
    ticketSelectArr(){
      return this.detailData.relation_ticket_list||[]
    },
    referId() {
      return this.detailData.relation.refer_id
    },
    customerId() {
      if(this.isFina){
        const {relation } = this.detailData||{}
        const {referrer } = relation
        return  referrer.id
      }
      return this.detailData.customer_id
    },
    supportLogsData() {
      // logs 數據
      return this.detailData.support_log || []
    },
    remarkLogsData() {
      // logs 數據
      return this.remarkDetail || []
    },
    showMain() {
      return !this.showEdit && !this.showBuyQuoteContainer && !this.showOther&&!this.showKyc
    },
    showReferEdit() {
      return this.referEdit && this.type === 1
    },
    showBusinessEdit() {
      return this.businessEdit && this.type === 4
    },
    isSmeBusiness() {
      const { product_id } = this.detailData.relation
      if(this.type == 7 && product_id < 50) return false
      return [5, 7].includes(Number(this.type))
    },
    showPolicyList() {
      const { product_id } = this.detailData.relation
      if(this.type == 7 && product_id < 50) return false

      return this.showPolicyAdded && [5, 7].includes(Number(this.type))
    },
    showPolicyAdded() {
      // const { order_id } = this.detailData.relation
      // const { policy_info } = this.detailData
      // if( order_id && policy_info) {
      //   return true
      // }
      // return false
      const { business_policy = [], business_quote = [] } = this.detailData
      return business_policy.length > 0
    },
    showQuoteAdded() {
      const { order_id } = this.detailData.relation
      const { policy_info } = this.detailData
      if(order_id && !policy_info) {
        return true
      }
      return false
    },
    showStatusBar() {
      return this.status == 3
    },
    showReplied() {
      const { refer_stts, customer_chose } = this.referDetail
      return [110, 105].includes(refer_stts) && !customer_chose
    },
    isSMEProduct(){
      return this.detailData.relation.product_id==80
    },
    showRepliedChose() {
      const { refer_stts, customer_chose,product_id } = this.referDetail
      return [110, 105].includes(refer_stts) && customer_chose  === 1
    },
    disabledUpgradBtn() {
      // 該單狀態為 reject 金庸 upgrade 按鈕
      return this.referDetail.refer_stts == 105
    },
    showDraft() {
      const { refer_stts, have_quo } = this.referDetail
      return refer_stts === 101 && have_quo
    },
    showBuyable() {
      return this.referDetail.refer_stts === 115
    },
    showPaymentLock() {
      return this.referDetail.refer_stts === 120
    },
    showBought() {
      return this.referDetail.refer_stts === 125
    },
    showRejectTransfer() {
      return this.detailData.relation.status === 3
    },
    showRemoveQueue() {
      return this.detailData.relation.status === 4
    },
    showDoneTransfer() {
      return this.detailData.is_snooze === 1
      return this.detailData.relation.status === 2
    },
    // endorsement 狀態
    isEndorsementDraft() {
      return this.detailData.relation.stts === 101
    },
    isEndorsementRepliedQuote() {
      return this.detailData.relation.stts === 201
    },
    isEndorsementBoughtPurchased() {
      // return true
      return this.detailData.relation.stts === 301
    },
    //撤回改单
    isEndorsementUndone() {
      return this.detailData.relation.stts === 401
    },
    isEndorsementCompleted() {
      return this.detailData.relation.stts === 601
    },
    isEndorsementIssuing() {
      return this.detailData.relation.stts === 501
    },
    // disabled 按钮
    disabledEndorsementMock() {
      return this.detailData.relation.stts !== 0
    },
    disabledBeginEndorsement() {
      const { status } = this.detailData
      return status == 3||[301,401,501,601].includes(this.detailData.relation.stts)
      // return this.detailData.relation.stts >= 201
    },
    isAttachCustomer(){
      let {customer={},customer_id}=this.detailData||{}
      // console.log('customer',customer,this.detailData)
      let {isrd_nm=''} = customer||{}
      return customer_id>0||this.isFina
      return isrd_nm?true:false
    },
    disabledRequestEdit() {
      if(this.type === 3) {
        return this.detailData.relation.stts >= 201
      }
      if(this.type === 7) {
        const { order_id } = this.detailData.relation
        return !!order_id
      }
      return false
    },
    disabledReplyQuote() {
      return this.showReplied
        || this.showRepliedChose
        || this.showBuyable
        || this.showPaymentLock
        || this.showBought
        || (this.showStatusBar && this.is_snooze !== 1)
    },
    disabledSnooze() {
      if(this.type === 4 && this.detailData.relation.is_snooze === 1) {
        return true
      }
      return this.detailData.relation.is_snooze === 1
      return this.showStatusBar && this.status !== 2
    },
    disabledResolved() {
      return this.showStatusBar && this.is_snooze !== 1
    },
    disabledEdit() {
      return (this.showStatusBar && this.is_snooze !== 1)
        || this.showBought
        || this.showPaymentLock
        || this.showBuyable
        || this.showRepliedChose
        || this.showReplied
        ||this.detailData.relation.stts > 0
    },
    disabledCreditMoveBtn() {
      const { status } = this.detailData
      // 1-pending, 2-paid, 3-cancel, 4-queue
      return [3, 4].includes(status)
    },
    disabledCreditRejectBtn() {
      const { status } = this.detailData
      // 1-pending, 2-paid, 3-cancel, 4-queue
      return [ 3, 4].includes(status)
    },
    showNewQuote() {
      const { relation } = this.detailData
      const { product_id } = relation
      return product_id < 50
    },
    disabledNewQuote() {
      const { relation } = this.detailData
      const { order_id } = relation
      return !this.isRegistered || !!order_id || this.isReferralRequestReject
    },
    disabledReferralReuqestAddPolicyBtn() {
      const { business_policy } = this.detailData
      return business_policy.length > 0 || !this.isRegistered || this.isReferralRequestReject
    },
    disabledReferralRequestRejectBtn() {
      const { relation } = this.detailData
      const { order_id } = relation
      return !!order_id || this.isReferralRequestReject
    },
    isRegistered() {
      const { relation } = this.detailData
      const { is_registered } = relation
      return !!is_registered
    },
    isReferralRequestQuoted() {
      const { relation } = this.detailData
      const { product_id, status, order_id } = relation
      return status === 0 && order_id && product_id < 50
    },
    isReferralRequestPolicy() {
      const { relation } = this.detailData
      const { product_id, status } = relation
      return status === 1 && product_id < 50
    },
    isReferralRequestReject() {
      const { relation } = this.detailData
      const { status } = relation
      return status === 2
    },
    title() {
      // 1-General 2-refer case 3-endorsement 4-credit transfer 5-business 6-Claims
      // 1=>'Open', 2=>'Snooze', 3=>'Resolved'
      let insuranceType = ''
      if(this.type == 5) {
        insuranceType = this.getOptionName('ticketOptions.allTypeOptions', this.detailData.relation.insurance_type)
      }
      const titleList = [
        'Can I claim when I am not in Hong Kong? Worry that someone may steal my car Customer Inputted Title',
        'Information Out of Guidelines During Final Underwriting',
        `Endorsement Request of Policy #${this.detailData.id}`,
        `Credit Transfer Request - ${this.detailData.relation.money}`,
        `Business Insurance Inquiry (${insuranceType})`,
        `Claim Request of Policy #${this.detailData.id}`
      ]
      const type = Number(this.type)-1
      return titleList[type]
    },
    claimDetailData() {
      const { id, relation } = this.detailData
      const {claim_log = []} = relation
      return {
        ticket_id: id,
        id: relation.id,
        log: claim_log
      }
    },
    showVoidQuoteBtn() {
      return this.detailData.stts != 0
    },
    isSignature(){
      const {is_signature} = this.referDetail
      return is_signature==1
    },
    customerData(){
      let{customer={}} = this.detailData||{}
      if(this.type==2){
        const {email,mobile_no,contact_phone} = this.referDetail||{}
        return{
          contact_phone:mobile_no||contact_phone,
          contact_email:email
        }
      }
      return{
        contact_phone:customer.phone||'',
        contact_email:customer.send_email||''
      }
    },
    customer(){
      let{customer={}} = this.detailData||{}
      return customer||{}
    },
    fina_referrer(){
      let{referrer={}} = this.relation||{}
      let{contact_data} = this.detailData||{}
      let{send_email,phone,contact_phone} = referrer||{}
      return {customer:this.type==2?this.referDetail.referrer:referrer,contact_data,customer_id:this.customerId,send_email,phone,contact_phone}||{}
    },
    orderId(){
      const { relation } = this.detailData||{}
      const { order_id } = relation ||{}
      return order_id||''
    },

    relationOrderId(){
      const { relation } = this.detailData || {}
      const { order_id } = relation || {}
      return order_id||''
    },
    isShowName(){
      let {customer,id_type} = this.detailData
      if(customer.isrd_nm)
        return customer.isrd_nm.trim()!=''
      else return  false
    },
    customerType() {
      return type =>{
        const {customer_id} =  this.detailData
        let customerId = customer_id
        // 一個是 client user
        if(type=='client') {
          customerId = this.detailData.relation.client_user_id
        }
        return  customerId||''
      }
    },
    pcyId(){
      return this.relationForm.pcy_id || this.policyData.pcy_id || this.detailData.relation.pcy_id
    },
    documentData(){
      return this.isSMEProduct?this.referData:this.detailData.relation
    },
    canQuoteAgain(){
      return this.type===2&&JSON.stringify(this.referDetail)!='{}'&&this.isSMEProduct||this.type==2&&!this.isSMEProduct
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile
      return block_data.length>0
    },
    isNewSME(){
      let path = this.$route.path
      return path.includes('/sme/')
    },
    claimStatus(){
      let {status} = this.relation||{}
      return status
    },
    isGuestTravel(){
      let {is_guest_order} = this.relation||{}
      return is_guest_order==1
    },
    quote_info(){
      let {quote_info={}} = this.detailData||{}
      return quote_info||{}
    },
    renew_send_data(){
      return {
        ...this.customer,
        ...this.detailData
      }
    },
    isVoidTicket(){
      let {status} = this.detailData||{}
      return status==4
    },
    referData(){
      let {order_id} = this.relation||{}
      return {...this.referDetail,order_id}
    }
  },
  watch: {
    ticketId: {
      immediate:true,
      async handler(val) {
        await  this.handler().initStatusUpdateData()
      }
    },
    // 刷新頁面數據
    refreshPage(val, old) {
      if(val > old) {
        let that = this
        setTimeout( ()=>{
          that.handler().initStatusUpdateData()
        },2000)
      }
    },
    // relationOrderId: {
    //   immediate: true,
    //   handler(val) {
    //     if(val && this.type == 3) {
    //       let params = {
    //         order_id: this.relationOrderId
    //       }
    //       this.handler().getPolicyProductData(true,params)
    //     }
    //   }
    // },
    customerId:{
      immediate:true,
      handler(val){
        if(val)
          this.network().getAccountDetail({customer_id:val})
      }
    },
    policyData:{
      immediate: true,
      deep: true,
      handler(val){
        // 如果没做过endorsement，手续费默认为0
        if(!this.isEndorsementRepliedQuote){
          val.handling_fee = 0
        }
      }
    },
    //2024-4-2先注释，不知道会不会影响
    // pcyId:{
    //   immediate: true,
    //   handler(val){
    //     if(val){
    //       let params = {
    //         pcy_id: val
    //       }
    //       this.handler().getPolicyProductData(false,params)
    //     }
    //   }
    // }
  },
  async created() {
    this.checkOptionsData()
    this.setQuoteCase([])
    if(this.orderId && !(this.isSMEProduct || this.isSmeBusiness)){
      this.network().getQuoteUrl()
    }
  },
  mounted(){
    this.container = this.$refs['container'].parentElement
  },
  methods: {
    // ...mapActions('common', ['updateGlobalOptions']),
    ...mapActions('common', ['setProductId', 'checkOptionsData', 'getCustomerOptionsPhone']),
    ...mapActions('ticket', ['setTicketData', 'setReferData','setQuoteCase']),
    ...mapActions('quote',['setQuoteForm']),
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    ...mapActions('smeQuote', ['setSmeQuickForm']),
    handleVoidTicket(){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        isGreen:true,
        message: 'Confirm void this ticket and its linked quotation?'
      }).then(()=>{
        this.network().voidRenewalTicket()
      })
    },
    async  handleEditClaimStatus(index){
      this.editClaimData = this.status_record[index]
      await this.handler().getUpdateRenewOrderSn()
      if(this.renew_order_sn){
        this.nextStep(6)
        return
      }
      this.showEdit = true
      this.showEidtClaim = 1
    },
    handlerEmailSmsSend(content,type,data){
      let {referrer_content} = data
      let params = {
        content,
        referrer_content
      }
      if(type==1){
        this.mixinNetwork().sendSMS(params)
      }
      else{
        this.mixinNetwork().sendEmail(params)
      }
    },
    handlerEmailSmsSkip(){
      this.network().rejectCreditTransfer()
    },
    handlerRejectTranfer(content){
      this.network().rejectCreditTransfer({content})
    },
    getUpdateAccountData() {
      this.network().getAccountDetail({customer_id:this.customerId})
    },
    editDescription(){
      this.$refs['edit-description'].changeDialog()
    },
    handlerSkip(){
      this.network().orderSkip()
    },
    handleQuoteAgain(){
      let params = this.detailData.relation||{}
      if(this.isSMEProduct)
        params = this.referDetail||{}
      delete params.order_sn
      delete params.order_id
      delete params.refer_id
      delete params.id
      if(this.isSMEProduct){

        this.setSmeQuickForm({
          ...params,
          copy:1
        })
      }else {
        this.setQuoteForm({
          ...params,
          copy: 1 // 標記是 copy kyc
        })
      }
      if(this.isFina){
        this.setReferCustomerId(this.detailData.referrer_id)
        this.setSelectReferCustomerData(this.detailData.referrer)
      }else {
        this.setCustomerId(this.customerId)
        this.setSelectCustomerData(this.customer)
      }
      let serverType = this.isFina?'fina':'holdcover'
      let path = `/quoting/${serverType}/underwriting`
      if(this.isSMEProduct) {
        let {class_id} = this.detailData.policy_info
        this.setProductId(class_id)
        path = `/quoting/${productAPiPath[class_id]}/underwriting`
      }
      this.$router.push({
        path:path,
        query:{
          source:params.ref_agency_id
        }
      })
    },
    handlerSetPolicy(){
      this.setPolicy =  !this.setPolicy
    },
    handlerSelectType(data){
      this.policyType=data
      this.setPolicy =false
      let params ={}
      if(data==2){
        params.is_new_handling=2
        this.network().setResolvedTicket(params)
      }
      if(data==3){
        this.network().setResolvedTicket()
      }
      if(data==4){
        this.network().reopenTicket(0)
      }
      if(data==1){
        params.is_new_handling=1
        this.network().setResolvedTicket(params)
      }
    },
    async handlerDialog(target) {
      await this.handler().getUpdateRenewOrderSn()
      if(target == 'change-claim-status'){
        if(this.renew_order_sn){
          this.nextStep(6)
          return
        }
        this.editClaimData = this.relation
        this.showEdit = true
        this.showEidtClaim = 1
      }else
        this.$refs[target].changeDialog()
    },
    routerTo(path) {
      this.$router.push(path)
    },
    handlerCreatePolicySuccess(data) {
      this.showAddQuote = false
      // this.showPolicyAddedPage = true
      this.showBusinessPayment = true
      this.businessPolicyOrderId = data.id
      this.handler().getUpdateDetailData()
    },
    handlerBusinessPaymentSuccess() {
      this.showBusinessPayment = false
      this.showPolicyAddedPage = true
      this.handler().getUpdateDetailData()
    },
    handlerOnAddPolicy() {
      this.businessPolicyOrderId = ''
      // event().onAddQuote(2)
      // 判斷是個人還是公司
      const { identity } = this.detailData.customer
      if(identity == 1) {
        this.$ConfirmBox({
          title: 'Add Policy',
          message: 'This ticket is attached to an individual account. Are you sure to continue?'
        }).then(() => {
          this.event().onAddQuote(2)
        })
      }
      else {
        this.event().onAddQuote(2)
      }
    },
    onViewEndorsementQuote() {
      this.network().getEndorsementQuoteView()
      // this.showMainRight = true
      // this.showEndorsementQuoteInfo = true
    },
    async beginEndorsCheckTips(){
      let {pcy_id=''} = this.policyData||{}
      if(!pcy_id)
      {
        await this.handler().getUpdatePolicyData()
      }
      if(this.renew_order_sn){
        this.showTips()
        this.step = 0
      }else{
        this.beginEndorsement()
      }
    },
    editDraftCheckTips(){
      if(this.renew_order_sn){
        this.showTips()
        this.step = 1
      }else{
        this.event().onEditEndorsementDraft()
      }
    },
    tipsContinue(){
      switch(this.step){
        case 0:
          // begin endorsement
          this.beginEndorsement()
          break
        case 1:
          // edit draft
          this.event().onEditEndorsementDraft()
          break
        case 2:
          // kyc -> next
          this.$refs['edit-policy'].handlerNext()
          break
        case 3:
          // kyc -> next -> save
          this.$refs['edit-policy'].handlerSaveDraft()
          break
        case 4:
          // kyc -> next -> deliver
          this.$refs['edit-policy'].onDeliver()
          break
        case 5:
          // change claim status -> submit
          this.$refs['edit-claim-status'].network().setClaimStatus()
          break
        case 6:
          // detail -> click Change Claim Status btn
          this.showEdit = true
          this.showEidtClaim = 1
          // this.$refs['change-claim-status'].changeDialog()
          break
      }
    },
    toBeginEndorsement(isBeginEndorsement=true){
      this.$router.push({
        path:'/tickets/begin/endorsement',
        query:{
          ticket_id:this.ticketId,
          product_id:this.productId,
          isBeginEndorsement:isBeginEndorsement
        }
      })
    },
    beginEndorsement() {
      // begin endorsement
      // 需要回填數據
      this.toBeginEndorsement()
      return
      this.showMainRight = true
      this.showBeginEndorsement = true
      // this.isEditEndorsementDraft = false
      this.isBeginEndorsement = true
    },
    mockCalculate() {
      this.showMainRight = true
      this.showMockCalculate = true
    },
    moveTransferQueue() {
      this.showMainRight = true
      this.editStatus=true
    },
    selectAssignee(id) {
      id = id?id:0
      this.network().setTicketCs({
        ticket_id: [this.detailData.id],
        assignee_id: id
      })
    },
    viewPlan() {
      // this.isPlan=true
      // this.$refs['plan-dialog'].changeDialog()
      // return
      this.$router.push({
        path: '/records/quote/plan',
        query: {
          customer_id: this.detailData.customer_id
        }
      })
    },
    viewCustomer(type) {
      const {customer_id} =  this.detailData
      let customerId = this.customerId
      // 一個是 client user
      if(type=='client') {
        customerId = this.detailData.relation.client_user_id
      }
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: customerId
        }
      })
    },
    viewTicket(ticketId) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: ticketId
        }
      })
    },
    onRejectTransfer() {
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Reject Request',
        confirmBtn:'Yes',
        cancelBtn:'Cancel',
        isGreen:true,
        message: 'Are you sure to reject this request? This' +
          '        cannot be undone.'
      }).then(async () => {
        this.$refs['send-fina-email-sms'].changeDialog()
      })
    },
    handlerRequestTransfer() {
      this.network().rejectCreditTransfer()
    },
    editCustomer(type) {
      if(type) {
        this.$refs['attach-user-client'].changeDialog()
        return
      }
      this.$refs['attach-user'].changeDialog()
    },
    openDialog(target) {
      this.$refs[target].changeDialog()
    },
    // 獲取 support logs type 數據
    changeSupportLogType(type) {
      this.supportLogType = type
      this.handler().getUpdateDetailData()
    },
    handlerSend(){
      let textareaElement = document.createElement('textarea')
      textareaElement.setAttribute('readonly', 'readonly') // 防止弹出输入编辑
      textareaElement .value = this.quoteUrl //将需要拷贝的内容设置到textarea元素中。
      document.body.appendChild(textareaElement )
      textareaElement .select() //选中textarea元素，以备调用系统copy函数复制其中的内容。
      let isSuccess = document.execCommand('copy')
      this.$NewMessageBox({
        title: 'Copy Link',
        message: 'The link has been copied to your clipboard',
        confirmBtn:'Done',
        btnType:'success'
      })
    },
    handlerContact(type,way) {
      this.contactType = type
      if(way == 'Buyable'){
        this.initContent = this.referDetail.refer_buyable_url_data
        this.way = 'Buyable'
      }else{
        this.initContent = this.quoteUrl
        this.way = ''
      }
      this.$refs['contact-dialog'].changeDialog()
    },
    handlerAddRemark(data) {
      this.network().addTicketRemark({
        ticket_id: this.ticketId,
        ...data
      })
    },
    handlerSendRemark(msg) {
      let content = msg? msg : this.message
      this.network().addTicketRemark({
        ticket_id: this.ticketId,
        content
      })
    },
    handlerChangeCategory(type) {
      this.changeCategory = type
      this.showEdit = true
    },
    cancelEdit() {
      this.showEdit = false
      this.changeCategory = '' // 重置
    },
    handleRefresh(){
      this.handler().getUpdateDetailData()
    },
    cancelRightEdit() {
      this.showMainRight = false
    },
    // endorsement 顯示主頁
    closeMainRightEndorsement() {
      this.showBeginEndorsement = false
      this.showEndorsementQuoteInfo = false
      this.showMainRight = false
    },
    nextStep(step){
      this.step = step
      this.showTips()
    },
    handleUpdateDetail(){
      this.handler().getUpdateRenewOrderSn()
    },
    closeMockCalculate() {
      this.showMockCalculate = false
      this.showMainRight = false
    },
    cancelOther() {
      this.showOther = false
      this.showAddQuote = false
      this.showPolicyAddedPage = false
    },
    handlerSave() {
      this.changeCategory = '' // 重置 change catagory 下拉框
      this.showEdit = false
      this.handler().getUpdateDetailData()
    },
    saveChangeCategory() {
      this.changeCategory = '' // 重置 change catagory 下拉框
      this.showEdit = false
      // this.network().getTicketDetail()
      this.handler().getUpdateDetailData()
    },
    // refer 編輯數據
    handlerReferSaveSuccess() {
      this.showEdit = false
      // this.network().getTicketDetail()
      this.handler().getUpdateDetailData()
    },
    // refer reply save draft
    handlerReferSaveDraft() {
      // todo
      this.showEdit = false
      // 重新加載數據
      // this.network().getTicketDetail()
      this.handler().getUpdateDetailData()

    },
    handlerReferReplyAll() {
      // todo
      this.showEdit = false
      // 重新加載數據
      // this.network().getTicketDetail()
      this.handler().getUpdateDetailData()
    },
    // refer complete reply
    handlerReferCompleteReply() {
      this.showEdit = false
      this.handler().getUpdateDetailData()
    },
    async onBuyQuote() {
      if(this.type==3){
        await this.handler().getUpdatePolicyData()
      }
      this.showBuyQuoteContainer = true
    },
    onEndorsementWithDrawQuote() {
      this.network().changeEndorsementStatus({
        stts: 101
      })
    },
    async onMarkEndorsed() {
      // this.network().changeEndorsementStatus({
      //   stts: 601
      // })
      let {pcy_id=''} = this.policyData||{}
      if(!pcy_id)
      {
        await this.handler().getUpdatePolicyData()
      }
      this.$refs['mark-as-endorsed-dialog'].changeDialog()
    },
    onMarkResolved() {
      this.network().changeEndorsementStatus({
        stts: 601
      })
    },
    // 編輯草稿
    async onEditDraftClick() {
      let params = {
        is_refresh_user:1
      }
      if(Number(this.productId)==80){
        await this.network().getSMEReferDetail(params)
      }else {
        await this.network().getCoressReferDetail(params)
      }
      this.showEdit = true
      // 標記是 reply
      this.checkRefer = 1
      this.referEditType = 1
    },
    // 編輯 reply quote
    async onEditRepliedClick() {
      let params = {
        is_refresh_user:1
      }
      if(Number(this.productId)==80){
        await this.network().getSMEReferDetail(params)
      }else {
        await this.network().getCoressReferDetail(params)
      }
      this.showEdit = true
      this.checkRefer = 1
      // 標記是 reply
      this.referEditType = 1
    },
    // withdraw quote
    onWithdrawClick() {
      this.network().changeReferralStts({
        reply_type: 4
      })
    },
    async onUpgradeQuoteClick(isRefer=false) {
      // todo
      let params = {}
      if(isRefer){
        params = {
          is_refresh_user:1
        }
      }
      if(Number(this.productId)==80){
        await this.network().getSMEReferDetail(params)
      }else {
        await this.network().getCoressReferDetail(params)
      }
      this.showEdit = true
      this.checkRefer = 2
      this.isShowQuick = 1
      this.referEditType = 2
    },
    onSendReferralSms() {
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerReferralSmsSend(content) {
      this.network().sendReferralSms(content)
    },
    showTips(){
      this.$refs['renew-tips'].changeDialog()
    },
    onDowngradeQuoteClick() {
      this.network().changeReferralStts({
        reply_type: 5
      })
    },
    handlerBusinessPaymentCancel() {
      this.showBusinessPayment = false
      this.showOther = false
    },
    routerToBusinessQuote(index) {
      const { id } = this.detailData.business_quote[index]
      this.businessPolicyOrderId = id
      this.showOther = true
      // this.showBusinessPayment = true
      this.showAddQuote = true
    },
    routerToBusinessPolicy(index) {
      const { pcy_id, id, product_id } = this.detailData.business_policy[index]
      this.$router.push({
        path: product_id > 50? '/records/policy/manual/detail': '/records/policy/detail',
        query: {
          id,
          pcy_id,
          product_id,
        }
      })
    },
    goViewPolicy(d, tab) {
      const {pcy_id} = this.detailData.policy_info
      let proudctId =''
      let orderId =''
      const { product_id,order_id,sme_versions } = this.detailData.relation
      proudctId = product_id
      orderId = order_id
      let isNewSme =sme_versions==3
      if (!proudctId)
        proudctId = this.detailData.policy_info.product_id||''
      if(!orderId)
        orderId = this.detailData.policy_info.id||''
      let query ={}
      if(pcy_id)
        query =  {
          id:orderId,
          pcy_id:pcy_id,
          product_id:proudctId,
          tab,
          sme_versions
        }
      else{
        query =  {
          id:orderId,
          product_id:proudctId,
          tab,
          sme_versions
        }
      }
      this.$router.push({
        path: proudctId == 90? '/records/micropolicy/detail' : product_id > 50&&!isNewSme? '/records/policy/manual/detail': '/records/policy/detail',
        query
      })
    },
    goViewQuote(id) {
      let order_id = id
      if(order_id instanceof Array) {
        order_id = order_id[0]
      }
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id,
          product_id: this.productId
        }
      })
    },
    handlerEditQuote() {
      this.event().onAddQuote(1)
      const { quotation_company_id, quotation_number, quote_file } = this.detailData.quote_info
      this.$refs['add-quote'].updateEditData({
        company_id: quotation_company_id,
        quotation_number,
        files: quote_file
      })
    },
    changeClaimStatus(status) {
      this.showEdit =false
      // this.detailData.relation.status = status
      this.handler().getUpdateDetailData()
    },
    // referral request
    onNewQuote() {
      this.showOther = true
      this.showNewQuotePage = true
    },
    handlerNewQuoteBack() {
      this.showNewQuotePage = false
      this.showOther = false
    },
    handlerNewQuoteSuccess() {
      this.showNewQuotePage = false
      this.showOther = false
      this.handler().getUpdateDetailData()
    },
    handlerCreateAccountBack() {
      this.showCreateAccount = false
      this.showOther = false
    },
    handlerCreateAccountSuccess() {
      this.showCreateAccount = false
      this.showOther = false
      this.handler().getUpdateDetailData()
    },
    onNewAccount() {
      this.showCreateAccount = true
      this.showOther = true
    },
    onMarkReject() {
      this.network().rejectReferralRequest()
    },
    handlerGetTicketDetail(){
      this.network().getTicketDetail()
    },
    // handlerSkipTransfer(){
    //   let params = {
    //     content: '',
    //     is_send: 0
    //   }
    //   if(this.$refs['move-transfer-queue']){
    //     this.$refs['move-transfer-queue'].network().addCreditTransferQueue(params)
    //   }else{
    //     this.network().sendSpendingMsg(params)
    //   }
    // },
    // handlerSendTransfer(content){
    //   let params ={
    //     content,
    //     is_send: 1
    //   }
    //   if(this.$refs['move-transfer-queue']){
    //     this.$refs['move-transfer-queue'].network().addCreditTransferQueue(params)
    //   }else{
    //     this.network().sendSpendingMsg(params)
    //   }
    // },
    event() {
      return {
        // begin endrosement draft
        onEditEndorsementDraft: () => {
          this.toBeginEndorsement(false)
          // this.showMainRight = true
          // this.showBeginEndorsement = true
          // this.isShowQuick = 0
          // // this.isEditEndorsementDraft = true
          // this.isBeginEndorsement = false
        },
        onAddQuote: (type) => {
          // 1 - quote, 2 - policy
          this.businessAddQuoteType = type
          this.showAddQuote = true
          this.showPolicyAddedPage = false
          this.showOther = true

          if(type === 2) {
            setTimeout(() => {
              this.$refs['add-quote'].initPolicyData(this.detailData.relation)
            }, 0)
          }

          // 存在 Policy 的情況下，add quote 也當成 edit 處理
          // 數據從 policy 拿
          if(type === 1 && this.showPolicyAdded) {
            const { quotation_company_id, quotation_number, quote_file } = this.detailData.policy_info
            this.$refs['add-quote'].updateEditData({
              company_id: quotation_company_id,
              quotation_number,
              files: quote_file
            })
          }
        },
        handleReplyQuote: () => {
          if((this.detailData.stts == 0 || this.detailData.stts == 1)&&!this.isSMEProduct){
            this.onUpgradeQuoteClick(true)
            // this.$refs['reply-quote'].changeDialog()
          }else{
            this.event().onReplyQuote()
          }
        },
        onReplyQuote: async () => {
          let params = {
            is_refresh_user:1
          }
          if(Number(this.productId)==80){
            await this.network().getSMEReferDetail(params)
          }else {
            await this.network().getCoressReferDetail(params)
          }
          // todo  可能要根據 type 判斷
          // 直接去到 edit refer 頁
          this.showEdit = true
          this.isShowQuick = 1
          // 標記是 reply
          this.checkRefer = 1
          this.referEditType = 1

        },
        downloadPdf: () => {
          this.$refs['download-pdf'].changeDialog()
        },
        // 控制顯示 edit 頁面
        handlerRequestEdit: async(type) => {
          if(type == 6)
            await this.handler().getUpdateRenewOrderSn()
          this.showEdit = true
          this.isShowQuick = 0
          this.showEidtClaim = 0
          // this.changeCategory = '' // 初始化一下
          // refer case
          if(type == 2) {
            this.referEditType = 0 // 正常 edit
          }

        },
        onUndoEndorsement: () => {
          const { undo_endorse_amount } = this.policyData
          if(undo_endorse_amount <= 0) {
            this.network().undoEndorsement()
          }
          else {
            this.undoEndorsementType= 1
            this.handlerDialog('undo-endorsement')
          }
        },
        onRemoveQueue: () => {
          this.network().removeCreditTransfer()
        },
        onAttatchTicket: () => {
          this.$refs['related-tickets'].changeDialog()
        }
      }
    },
    // sendSms(){
    //   this.$refs['send-email-sms-transfer'].changeDialog()
    // },
    handler() {
      return {
        // 初始化頁面狀態並更新並更新詳情數據
        initStatusUpdateData: async () => {
          this.showBuyQuoteContainer = false
          this.showEdit = false
          this.showAddQuote = false
          // this.showPolicyAddedPage = false
          this.showOther = false
          this.showMainRight = false
          this.showBeginEndorsement = false
          this.showEndorsementQuoteInfo = false
          this.showMockCalculate = false
          await  this.handler().getUpdateDetailData()
        },
        getUpdateDetailData: async (params) => {
          //获取信息详情
          await this.network().getTicketDetail()
          await this.network().getRemarkDetail()
          // refer
          // if(this.type === 2) {
          //   await this.network().getCarReferDetail()
          // }
          const type = Number(this.type)
          switch (type) {
            case 2:
              switch(Number(this.productId)) {
                case 80:
                  await this.network().getSMEReferDetail(params)
                  break
                default:
                  await this.network().getCoressReferDetail(params)
                  break
              }
              break
            case 3:
              // const { endorse_order_id, order_id } = this.detailData.relation
              // const orderId = endorse_order_id? endorse_order_id: order_id
              // let params = {
              //   order_id: orderId
              // }
              // await this.handler().getPolicyProductData(false,params)
              break
          }
        },
        getUpdateRenewOrderSn: async () => {
          const { endorse_order_id, order_id } = this.detailData.relation
          const orderId = endorse_order_id? endorse_order_id: order_id
          let params = {
            order_id: orderId,
            pcy_id: this.pcyId
          }
          await this.handler().getPolicyProductData(false,params)
        },
        getUpdatePolicyData: async () => {
          const { endorse_order_id, order_id } = this.detailData.relation
          const orderId = endorse_order_id? endorse_order_id: order_id
          let params = {
            order_id: orderId,
          }
          await this.handler().getPolicyProductData(false,params)
        },
        getPolicyDetail: async () => {
          const { endorse_order_id, order_id } = this.detailData.relation
          if(this.productId>=80)
          {
            await this.network().newSMEPolicyDetail(order_id)
          }
          else{
            await  this.network().getPolicyDetail(order_id)
          }
          if(endorse_order_id) {
            if(this.productId>=80)
            {
              await this.network().newSMEPolicyDetail(endorse_order_id, true)
            }
            else{
              await  this.network().getPolicyDetail(endorse_order_id, true)
            }
          }
        },

        getPolicyProductData: async (isRelation = false,params) => {
          if(this.productId>=80)
          {
            await this.network().newSMEPolicyDetail(isRelation,params)
            return
          }
          await this.network().getPolicyDetail(isRelation,params)
        }
      }
    },
    network() {
      return {
        voidRenewalTicket: async (params) => {
          let {data} = await voidRenewalTicket({
            ticket_id: this.ticketId
          })
          await  this.handler().getUpdateDetailData()
        },
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        getTicketDetail: async (params = {}) => {
          const { data } = await getTicketDetail({
            id: this.ticketId,
            type: this.supportLogType,
            ...params
          })
          this.detailData = data
          this.assignee = this.detailData.cs_id
          // this.type = data.type
          this.setTicketData(data)
          this.setProductId(data.relation.product_id || 11)

          if(this.type == 7) {
            const { product_id, client_user_id } = data.relation
            // this.setProductId(product_id)
            this.setQuoteForm(null)
            this.setCustomerId(client_user_id)
          }
          if(this.isRenewalTicket&&!this.isFirstLoad){
            this.mixinHandler().getProductData()
            this.isFirstLoad = true
          }
        },
        getRemarkDetail: async () => {
          const { data } = await getTicketRemark({
            ticket_id: this.ticketId,
          })
          this.remarkDetail = data
        },
        addTicketRemark: async params => {
          const { data } = await addTicketRemark(params)
          this.$refs['add-mark'].initData()
          this.handler().getUpdateDetailData()
          this.message = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
        },
        // 更改轉介單狀態
        // 4： With Draw Quote  退回第一次發出報價
        // 5： Download to Price Quote  退回第二次發出報價
        changeReferralStts: async params => {
          const { data } = await changeReferralStts({
            refer_id: this.referId,
            ...params
          })
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          // 刷新數據
          // this.network().getTicketDetail()
          this.handler().getUpdateDetailData()
          return 'success'
        },
        // 获取refer 详情
        getCoressReferDetail: async (params) => {
          const { data } = await getCoressReferDetail({
            refer_id: this.referId,
            hideLoading: true,
            ...params
          },this.productId)
          this.referDetail = data
          this.setReferData(data)
        },
        getSMEReferDetail: async (params) => {
          let {policy_info,relation} = this.detailData||{}
          let {order_id} = relation||{}
          let {class_id} = policy_info||{}
          const { data } = await getSMEReferDetail({
            order_id: order_id,
            hideLoading: true,
            ...params
          },class_id)
          this.referDetail = data
          this.setReferData(data)
        },
        newSMEPolicyDetail: async (isRelation,params) => {
          let {data} = await newSMEPolicyDetail({
            ...params,
          })
          if(data.pcy_id){
            this.renew_order_sn = data.renew_order_sn
            this.renewStts = data.renew_stts
            // return
          }
          if(isRelation) {
            this.relationForm = data
            return
          }
          // this.relationForm = data
          this.policyData = data
        },
        // 獲取 policy 詳情數據
        getPolicyDetail: async (isRelation,params) => {
          const { data } = await getPolicyDetail(params,this.productId)

          if(data.pcy_id){
            this.renew_order_sn = data.renew_order_sn
            this.renewStts = data.renew_stts
            // return
          }

          if(isRelation) {
            this.relationForm = data
            return
          }
          // this.relationForm = data
          this.policyData = data
          // this.loading = false
        },
        // unsnooze
        setTicketUnsnooze: async () => {
          const { data } = await setTicketUnsnooze({
            ticket_id: [this.detailData.id]
          })
          this.handler().getUpdateDetailData()
        },
        setTicketCs: async params => {
          const { data } = await setTicketCs(params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        reopenTicket: async () => {
          const { data } = await reopenTicket({
            ticket_id: this.detailData.id
          })
          this.handler().getUpdateDetailData()
        },
        changeEndorsementStatus: async params => {
          const { data } = await changeEndorsementStatus({
            ...params,
            id: this.detailData.relation.id
          })
          this.handler().initStatusUpdateData()
        },
        getEndorsementQuoteView: async () => {
          const { data } = await getEndorsementQuoteView({
            id: this.detailData.relation.id
          })
          this.endorsementQuote = data
          this.showMainRight = true
          this.showEndorsementQuoteInfo = true
        },
        undoEndorsement: async (params) => {
          const { data } = await undoEndorsement({
            id: this.detailData.relation.id,
            ...params
          })
          this.undoEndorsementType = 0
          this.handlerDialog('undo-endorsement')
        },
        rejectCreditTransfer: async (params) => {
          const { data } = await rejectCreditTransfer({
            transfer_id: this.detailData.relation.id,
            ...params
          })
          this.handler().getUpdateDetailData()
        },
        removeCreditTransfer: async () => {
          const { data } = await removeCreditTransfer({
            transfer_id: this.detailData.relation.id
          })
          this.handler().getUpdateDetailData()
        },
        // reject
        rejectReferralRequest: async () => {
          const { data } = await rejectReferralRequest({
            referral_request_id: this.detailData.relation.id
          })
          this.handler().getUpdateDetailData()
        },
        sendEndorsementInsurer: async (params) => {
          const { data } = await sendEndorsementInsurer({
            id: this.detailData.relation.id,
            ...params
          })
          this.handler().getUpdateDetailData()
        },
        sendReferralSms: async content => {
          const { data } = await sendReferralSms({
            order_id: this.detailData.relation.order_id,
            content
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          // this.$refs['send-email-sms'].changeDialog()
        },
        setResolvedTicket: async (params) => {
          const { data } = await setResolvedTicket({
            ticket_id: [this.ticketId],
            ...params
          })
          this.handler().getUpdateDetailData(0)
        },
        getQuoteUrl: async () => {
          const {data} = await getQuoteUrl({
            order_id: this.orderId
          })
          this.quoteUrl = data.quote_url
        },
        orderSkip: async params => {
          const {data} = await orderSkip({
            order_id: this.orderId,
          })
          this.handler().getUpdateDetailData()
        },
        // sendSpendingMsg: async params => {
        //   const {data} = await sendSpendingMsg({
        //     transfer_id: this.detailData.relation.id,
        //     ...params
        //   })
        //   if(data.code == 1000){
        //     this.$refs['send-email-sms-transfer'].changeDialog()
        //     this.$message({
        //       message: 'Success',
        //       type: 'success'
        //     })
        //   }
        // }
      }
    },
    async handlerUndo(){
      // onUndoEndorsement
      await this.handler().getUpdatePolicyData()
      let {amount} = this.policyData
      this.isUndo = true
      if(amount > 0) {
        this.$refs['set-void-quote'].changeDialog(amount)
      }else {
        this.network().undoEndorsement()
      }
    },
    async handlerDeliver() {
      //  調用接口判斷顯示哪個彈窗
      // dialogType = 0- normal、refund、no difference
      await this.handler().getUpdatePolicyData()
      let {amount} = this.policyData
      this.isUndo = false
      // if(this.detailData.relation.action!=1) {
      //   if(amount > 0) {
      //     this.$refs['set-void-quote'].changeDialog(amount)
      //   }
      //   else {
      //     this.network().sendEndorsementInsurer()
      //   }
      // } else {
      if(amount< 0) {
        this.$refs['set-void-quote'].changeDialog(amount)
      }
      else {
        // this.dialogType = 0
        // this.network().deliverEndorsement()
        this.network().sendEndorsementInsurer()
      }
      // }

    },
    handlerVoid(data){
      if(this.isUndo)
        this.network().undoEndorsement(data)
      else
        this.network().sendEndorsementInsurer(data)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../assets/css/pay-main-header';
  .page-container {
    position: relative;
    color: #303133;
    background: #fff;
    margin: -20px;
    height: 100%;
    .hand{
      cursor:pointer;
    }
    .small{
      font-weight: normal!important;
    }
    .unname{
      font-style:italic;
      font-weight: normal!important;
    }
    .none-data{
      color: #6A737D;
    }
    .flex-wrap{
      flex-wrap: wrap;
      text-decoration: none;
    }
    .top-bar {
      padding-top: 5px;
      color: #e6a23d;
      font-size: 13px;
      font-weight: bold;
      border-top: 2px solid #e6a23d;
    }

    .span-status{
      padding: 1px 8px;
      color: #fff;
      border-radius: 50px;
      font-size: 14px;
      margin-right: 10px;
      background: #fff;
    }
    .status-bar-span{
      padding: 1px 8px;
      border-radius: 25px;
      white-space: nowrap;
      height: 18px;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #24292E;
      background: #fff;
      margin-right: 15px;
      &.red{
        border: 1px solid $red;
        color: $red;
      }
    }
    .span-status-stts{
      //font-family: Inter;
      padding: 1px 8px;
      border-radius: 25px;
      white-space: nowrap;
      height: 18px;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      margin-right: 15px;
      color: #fff!important;
      //height: 18px;

      //background: #E36209;
      border-radius: 100px;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
      &.purple {
        background: #6F42C1;
      }
      &.gray {
        background: rgba(106, 115, 125, 1);
      }
    }
    .yellow{
      border: 1px solid #735C0F;
      color: #735C0F;
    }
    .pending{
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    .green{
      border: 1px solid #22863A;
      color: #22863A;
    }
    .warning{
      padding: 20px 70px;
    }
    .main-container {
      padding: 0 70px;
      display: flex;
      justify-content: space-between;
      margin: 0px auto 0 auto;
      background: #fff;
      // max-width: 100%;
      // overflow: auto;
      .left-col {
        margin-right: 15px;
        width: 250px;
        color: #616266;

        .title {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
          font-size: 14px;
        }

        .name {
          display: block;
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 16px;
        }

        .label {
          display: inline-block;
          margin: 10px 0;
          font-size: 14px;
          color: #616266;
          font-weight: 500;
        }

        .el-button {
          margin-top: 20px;
        }



        .info-container {
          margin: 10px -15px 0 -15px;
          padding: 0 15px 10px 15px;
          border-top: 1px solid #dddfe7;
          border-bottom: 1px solid #dddfe7;

          .plan-info-box {
            .logo {
              width: 80px;
              height: 45px;

              img {
                max-width: 80px;
                max-height: 45px;
              }
            }

            p {
              padding-left: 10px;
              font-size: 14px;
              line-height: 18px;
              font-weight: 500;
              color: #616266;
            }
          }

          .info-box {
            margin: 5px 0 0 0;
            color: #616266;

            & > div:last-child {
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }

      .main-col {
        flex: 1;
        display: flex;
      }

      .main-edit {
        width: 100%;
        .top-header {
          display: flex;

          .card:last-child {
            margin-left: 15px;
            width: 250px;
          }

          .title {
            display: inline-block;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: bold;
          }

          .btn-list {
            .el-button {
              display: block;
              margin: 0 0 5px 0;
            }
          }
        }
      }

      .middle-col {
        flex: 1;
        min-width: 600px;
        /*width: calc(100% - 280px)!important;*/
        .card {
          margin-bottom: 15px;
        }

        .draft-container {
          padding: 10px;
          background: #91939A;
          border-radius: 4px;
          color: white;

          span {
            display: block;
          }

          .title {
            font-size: 16px;
            font-weight: bold;
            color: white;
          }

          .msg {
            padding: 5px 0;
            font-size: 14px;
          }
        }

        .el-tabs {
          margin: 10px 0 0 0;
        }
      }

      .info-container {
        color: #616266;

        h1 {
          padding-bottom: 10px;
          font-size: 24px;
        }

        .info-content {
          display: flex;
          justify-content: space-between;
          margin: 0 -15px;
          padding: 0 15px 0 15px;
          // border-top: 1px solid rgba(0, 0, 0, 0.1);
          color: #91939a;
          font-size: 14px;

          .label {
            display: block;
            // margin-bottom: 10px;
            font-size: 14px;
            font-weight: bold;
            color: #616266;
          }
        }
      }

      .right-col {
        margin-left: 30px;
        width: 280px;
        //padding:0 0 0 15px;
        .icon{
          margin-right: 15px;
          img{
            height: 22px;
            width: 22px;
          }
        }
        .icon-content{
          height: 22px;
          width: 22px;
          border-radius: 5px;
          background-color: #E1E4E8;
          color: #6A737D;
          font-size: 14px;
          text-align: center;
          line-height: 22px;
          display: inline-block;
        }
        .box-remark{
          border-bottom: 0!important;
        }
        .box{
          padding: 29.5px 0;
          border-bottom: 1px solid #D1D5DA;
        }
        .plan-name{
          color: #0366D6;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0;
        }

        .button-weight{
          color: #24292E;
          font-family: Inter;
          //font-size: 14px;
          font-weight: 500!important;
          //padding: 6.5px 17px;
          padding: 10px 20px;
          &.is_snooze{
            background: #DBAB09;
            border: 1px solid rgba(27, 31, 35, 0.15);
            color: #FFFFFF;
          }
        }

        ul {
          margin-top: 15px;
          li {
            display: flex;
            padding: 5px;
            list-style: none;
            color: #606266;
            font-size: 12px;
            line-height: 14px;
            span {
              flex: 1;
              .tag{
                .span-tag{
                  display: inline-block;
                  border-radius: 100px;
                  height: 18px;
                  background: #FFFFFF;
                  padding: 0px 8px;
                  font-weight: 600;
                  font-size: 12px;
                  line-height: 18px;
                  box-sizing: content-box;
                  white-space: nowrap;
                  margin-bottom: 4px;
                  &.verified{
                    border: 1px solid #22863a;
                    color: #22863a;
                  }
                  &.pending_verify{
                    border: 1px solid #dbab09;
                    color: #dbab09;
                  }
                  &.not_verify{
                    border: 1px solid #d73a49;
                    color: #d73a49;
                  }
                  &.unread-uplod{
                    border: 1px solid #f66a0a;
                    color: #c24e00;
                  }
                  &.professional-status, &.coupon-status, &.discount-status{
                    border: 1px solid #0366d6;
                    color: #0366d6;
                  }
                  &.green {
                    background: #DCFFE4;
                    color: #28A745;
                    border: none;
                  }
                  &.orange {
                    background-color:#FFF5B1 ;
                    color:  #B08800;
                    border: none;
                  }
                  &.red {
                    background: #D73A49;
                    color:#fff;
                    border: none;
                  }
                }
              }
            }

            span:first-child {
              font-weight: bold;
            }
          }
          li:first-child {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }
          li:last-child {
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
          }
          margin-bottom: 15px;
        }
        .span-status{
          border: 1px solid #616266;
          color: #616266;
        }
        .card {
          margin-bottom: 15px;
        }

        .border-b {
          //margin: 10px -15px 0 -15px;
          padding: 0 15px 10px;
          border-bottom: 1px solid #dddfe7;

          .title {
            margin-bottom: 5px;
          }
        }

        .action-box {
          margin: 10px -15px 0 -15px;
          padding: 10px 15px;
          border-top: 1px solid #dddfe7;
          border-bottom: 1px solid #dddfe7;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          padding-top: 5px;
          font-size: 14px;
          font-weight: bold;
        }

        .el-input, .el-select {
          margin-bottom: 10px;

          & + .el-button {
            margin-bottom: 10px;
          }
        }
        .button-width{
          .el-button{
            width: 100%;
            font-size: 14px;
          }
        }
        .flex-align-center{
          align-items: center;
        }
        .customer-ava{
          height: 28px;
          width: 28px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #DBEDFF;
          margin-right: 10px;
          img{
            width: 100%;
            display: block;
            border-radius: 50%;
          }
        }
        .amount-payable {
          border: 1px solid rgba(4,66,137,0.2);
          border-radius: 10px;
          background-color: #DBEDFF;
          //margin-bottom: 30px;
          &.border-b{
            margin-top: 0;
          }
          .title {
            margin-bottom: 0;
            padding-top: 15px;
            padding-bottom: 5px;
          }

          .amount {
            display: block;
            padding-bottom: 20px;
            font-size: 28px!important;
            color: #586069;
          }
          .payment-disblock{
            display: block!important;
            .size-blue{
              color: #0366D6;
              font-family: Inter;
              font-size: 12px;
              cursor: pointer;
            }
          }
          .payment-status{
            display:flex ;
            justify-content: space-between;
            margin-bottom: 10px;
            .flex{
              align-items: center;
            }
            .dot{
              margin-right: 8px;
              display: block;
              border-radius: 50%;
              height: 16px;
              width: 16px;
              border: 1px solid rgba(0,0,0,0.2);
              background-color: #D73A49;
            }
            .green{
              background: #28A745!important;
            }
            .icon{
              margin-right: 5px;
            }
            .text-color{
              color: #0366D6;
              font-size: 12px;
            }
            .size-italic{
              font-style:italic;
              font-size: 12px;
              color: #6A737D;
            }
          }
          .send-color{
            color: #0366D6;
            font-size: 14px;
            font-weight: 500;
          }
          .button-list{
            margin: 20px 0;
            .el-button{
              margin-right: 8px;
              width: 50%;
              font-size: 14px;
            }
          }

        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }

        .remark-add {
          z-index: 2;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          //border-top: 1px solid #dddfe7;
        }

        .remarks-container {
          z-index: 1;
          max-height: 300px;
          overflow-y: auto;

          .remark-box {
            margin-bottom: 10px;
            font-size: 12px;
            color: #91939a;

            .remark-header {
              display: flex;
              justify-content: space-between;

              span:first-child {
                font-weight: bold;
              }
            }

            p {
              padding-bottom: 10px;
              color: #616266;
            }
          }
        }
      }
    }

    .dialog-container {
      padding-left: 15px;
      color: #616266;

      h1 {
        font-size: 24px;
      }

      .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 -15px;
        padding: 0 15px 15px 15px;
        border-bottom: 1px solid #dddfe7;

        h1 {
          font-size: 24px;
        }
      }

      .dialog-content {
        padding-top: 15px;

        & > div {
          flex: 1;
        }

        .left {
          margin-top: -15px;
          padding-right: 15px;
          padding-top: 15px;
          border-right: 1px solid #dddfe7;
        }

        .right {
          padding-left: 15px;
        }

        .form-box {
          margin-bottom: 10px;

          .label {
            display: block;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
    .void-status{
      background-color: #FFE3E6!important;
    }
    .paid-status{
      background-color: #DCFFE4!important;
    }
    .unbuyable-status{
      background-color: #FFFBDD!important;
    }
    .void-color{
      color: #CB2431;
    }
    .incomplete-status{
      background: #FFFBDD;
    }
    .main-header{
      padding: 20px 70px 0px 70px;
      border-bottom: 1px solid #D1D5DA;
      background-color: #FAFBFC;
      .icon-color{
        color:#6A737D;
      }
      ::v-deep .el-tabs__header{
        margin-bottom: 0;
      }
      ::v-deep .el-tabs--top{
        margin-top: 0;
      }
      .margin-bottom{
        padding-bottom: 20px;
      }
      .type-margin{
        margin-bottom: 20px;
      }
    }
  }
  .bg-green {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #68C23A;
    color: white;
    p {
      padding-bottom: 5px;
    }
  }
  .bg-green__radius{
    background: #DCFFE4;
    border-radius: 15px;
    border: 1px solid rgba(23, 111, 44, 0.2);
  }
  .bg-red__radius{
    background: #FFE3E6!important;
    border-radius: 15px;
    border: 1px solid rgba(158, 23, 35, 0.2)!important;
  }
  .bg-warning {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #e6a23d;
    color: white;
    p {
      padding-bottom: 5px;
    }
  }
  .bg-skyblue {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #409eff;
    color: white;
    p {
      padding-bottom: 5px;
    }
  }
  .bg-blue {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #d9ecff;
  }

  .bg-gray {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 20px 15px;
    background: #91939a;
    color: white;
    p {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .bg-small-blue {
    background: rgba(219, 237, 255, 1);
    border: 1px solid rgba(4, 66, 137, 0.2)
  }
  .bg-block {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 20px 15px;
    p {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .bg-green {
    background: #28a745;
    color: white;
  }
  .bg-red {
    background: #D73A49;
    color: white;
  }
  .bg-danger {
    background: #f56c6d;
    color: white;
  }
  .bg-b3d9ff {
    background: #b3d9ff;
  }
  .bg-warning {
    background: #e6a23d;
    color: white;
    .label {
      color: white;
    }
    &__yellow {
      background: #FFFBDD;
      border-radius: 15px;
      border: 1px solid rgba(176, 136, 0, 0.2);
      .flex,.flex__button{
        .width-80{
          width: 80%;
        }
      }
    }
  }
  .bg-sky-blue__radius{
    background: #DBEDFF;
    border: 1px solid rgba(176, 136, 0, 0.2);
    border-radius: 15px;
  }
  .bg-sky-blue {
    background: #409EFF;;
    color: white;
    &.__radius{
      background: #DBEDFF;
      border: 1px solid #044289;
      border-radius: 15px;
    }
    .label {
      color: white;
    }
  }
  ::v-deep .edit-container{
    padding: 0px!important;
  }
  .tr-margin{
    margin-bottom: 10px;
  }
  .tr-a{
    display: block;
  }


    .setting  .page-container {
      position: relative;
      color: #303133;
      background: #fff;
      margin: -20px;
      .hand{
        cursor:pointer;
      }
      .small{
        font-weight: normal!important;
      }
      .unname{
        font-style:italic;
        font-weight: normal!important;
      }
      .flex-wrap{
        flex-wrap: wrap;
        text-decoration: none;
      }
      .top-bar {
        padding-top: 5px;
        color: #e6a23d;
        font-size: 13px;
        font-weight: bold;
        border-top: 2px solid #e6a23d;
      }
      .main-container {
        padding: 0 70px;
        display: flex;
        justify-content: space-between;
        margin: 20px auto 0 auto;
        // max-width: 100%;
        // overflow: auto;
        .left-col {
          margin-right: 15px;
          width: 250px;
          color: #616266;

          .title {
            display: block;
            margin-bottom: 5px;
            font-weight: bold;
            font-size: 14px;
          }

          .name {
            display: block;
            margin-bottom: 10px;
            font-weight: bold;
            font-size: 16px;
          }

          .label {
            display: inline-block;
            margin: 10px 0;
            font-size: 14px;
            color: #616266;
            font-weight: 500;
          }

          .el-button {
            margin-top: 20px;
          }



          .info-container {
            margin: 10px -15px 0 -15px;
            padding: 0 15px 10px 15px;
            border-top: 1px solid #dddfe7;
            border-bottom: 1px solid #dddfe7;

            .plan-info-box {
              .logo {
                width: 80px;
                height: 45px;

                img {
                  max-width: 80px;
                  max-height: 45px;
                }
              }

              p {
                padding-left: 10px;
                font-size: 14px;
                line-height: 18px;
                font-weight: 500;
                color: #616266;
              }
            }

            .info-box {
              margin: 5px 0 0 0;
              color: #616266;

              & > div:last-child {
                font-size: 14px;
                font-weight: bold;
              }
            }
          }
        }

        .main-col {
          flex: 1;
          display: flex;
        }

        .main-edit {
          width: 100%;
          .top-header {
            display: flex;

            .card:last-child {
              margin-left: 15px;
              width: 250px;
            }

            .title {
              display: inline-block;
              margin-bottom: 10px;
              font-size: 14px;
              font-weight: bold;
            }

            .btn-list {
              .el-button {
                display: block;
                margin: 0 0 5px 0;
              }
            }
          }
        }

        .middle-col {
          flex: 1;
          min-width: 600px;
          /*width: calc(100% - 280px)!important;*/
          .card {
            margin-bottom: 15px;
          }

          .draft-container {
            padding: 10px;
            background: #91939A;
            border-radius: 4px;
            color: white;

            span {
              display: block;
            }

            .title {
              font-size: 16px;
              font-weight: bold;
              color: white;
            }

            .msg {
              padding: 5px 0;
              font-size: 14px;
            }
          }

          .el-tabs {
            margin: 10px 0 0 0;
          }
        }

        .info-container {
          color: #616266;

          h1 {
            padding-bottom: 10px;
            font-size: 24px;
          }

          .info-content {
            display: flex;
            justify-content: space-between;
            margin: 0 -15px;
            padding: 0 15px 0 15px;
            // border-top: 1px solid rgba(0, 0, 0, 0.1);
            color: #91939a;
            font-size: 14px;

            .label {
              display: block;
              // margin-bottom: 10px;
              font-size: 14px;
              font-weight: bold;
              color: #616266;
            }
          }
        }

        .right-col {
          margin-left: 30px;
          width: 280px;
          //padding:0 0 0 15px;
          .icon{
            margin-right: 15px;
            img{
              height: 22px;
              width: 22px;
            }
          }
          .icon-content{
            height: 22px;
            width: 22px;
            border-radius: 5px;
            background-color: #E1E4E8;
            color: #6A737D;
            font-size: 14px;
            text-align: center;
            line-height: 22px;
          }
          .box-remark{
            border-bottom: 0!important;
          }
          .box{
            padding: 29.5px 0;
            border-bottom: 1px solid #D1D5DA;
          }
          .plan-name{
            color: #0366D6;
            font-family: Inter;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0;
            text-decoration: none!important;
          }

          .button-weight{
            color: #24292E;
            font-family: Inter;
            //font-size: 14px;
            font-weight: 500!important;
            //padding: 6.5px 17px;
            padding: 10px 20px;
          }

          ul {
            margin-top: 15px;
            li {
              display: flex;
              padding: 5px;
              list-style: none;
              color: #606266;
              font-size: 12px;
              line-height: 14px;
              span {
                flex: 1;
              }

              span:first-child {
                font-weight: bold;
              }
            }
            margin-bottom: 15px;
          }
          .span-status{
            border: 1px solid #616266;
            color: #616266;
          }
          .card {
            margin-bottom: 15px;
          }

          .border-b {
            //margin: 10px -15px 0 -15px;
            padding: 0 15px 10px;
            border-bottom: 1px solid #dddfe7;

            .title {
              margin-bottom: 5px;
            }
          }

          .action-box {
            margin: 10px -15px 0 -15px;
            padding: 10px 15px;
            border-top: 1px solid #dddfe7;
            border-bottom: 1px solid #dddfe7;
          }

          .title {
            display: inline-block;
            margin-bottom: 10px;
            padding-top: 5px;
            font-size: 14px;
            font-weight: bold;
          }

          .el-input, .el-select {
            margin-bottom: 10px;

            & + .el-button {
              margin-bottom: 10px;
            }
          }
          .button-width{
            .el-button{
              width: 100%;
              font-size: 14px;
            }
          }
          .flex-align-center{
            align-items: center;
          }
          .customer-ava{
            height: 28px;
            width: 28px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #DBEDFF;
            margin-right: 10px;
            img{
              width: 100%;
              display: block;
              border-radius: 50%;
            }
          }
          .amount-payable {
            border: 1px solid rgba(4,66,137,0.2);
            border-radius: 10px;
            background-color: #DBEDFF;
            //margin-bottom: 30px;
            &.border-b{
              margin-top: 0;
            }
            .title {
              margin-bottom: 0;
              padding-top: 15px;
              padding-bottom: 5px;
            }

            .amount {
              display: block;
              padding-bottom: 20px;
              font-size: 28px!important;
              color: #586069;
            }
            .payment-disblock{
              display: block!important;
              .size-blue{
                color: #0366D6;
                font-family: Inter;
                font-size: 12px;
                cursor: pointer;
              }
            }
            .payment-status{
              display:flex ;
              justify-content: space-between;
              margin-bottom: 10px;
              .flex{
                align-items: center;
              }
              .dot{
                margin-right: 8px;
                display: block;
                border-radius: 50%;
                height: 16px;
                width: 16px;
                border: 1px solid rgba(0,0,0,0.2);
                background-color: #D73A49;
              }
              .green{
                background: #28A745!important;
              }
              .icon{
                margin-right: 5px;
              }
              .text-color{
                color: #0366D6;
                font-size: 12px;
              }
              .size-italic{
                font-style:italic;
                font-size: 12px;
                color: #6A737D;
              }
            }
            .send-color{
              color: #0366D6;
              font-size: 14px;
              font-weight: 500;
            }
            .button-list{
              margin: 20px 0;
              .el-button{
                margin-right: 8px;
                width: 50%;
                font-size: 14px;
              }
            }

          }

          .btn-list {
            .el-button {
              display: block;
              margin: 0 0 5px 0;
            }
          }

          .remark-add {
            z-index: 2;
            margin: 0 -15px;
            padding: 15px 15px 0 15px;
            //border-top: 1px solid #dddfe7;
          }

          .remarks-container {
            z-index: 1;
            max-height: 300px;
            overflow-y: auto;

            .remark-box {
              margin-bottom: 10px;
              font-size: 12px;
              color: #91939a;

              .remark-header {
                display: flex;
                justify-content: space-between;

                span:first-child {
                  font-weight: bold;
                }
              }

              p {
                padding-bottom: 10px;
                color: #616266;
              }
            }
          }
        }
      }

      .dialog-container {
        padding-left: 15px;
        color: #616266;

        h1 {
          font-size: 24px;
        }

        .dialog-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 -15px;
          padding: 0 15px 15px 15px;
          border-bottom: 1px solid #dddfe7;

          h1 {
            font-size: 24px;
          }
        }

        .dialog-content {
          padding-top: 15px;

          & > div {
            flex: 1;
          }

          .left {
            margin-top: -15px;
            padding-right: 15px;
            padding-top: 15px;
            border-right: 1px solid #dddfe7;
          }

          .right {
            padding-left: 15px;
          }

          .form-box {
            margin-bottom: 10px;

            .label {
              display: block;
              padding-bottom: 5px;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }
      .void-status{
        background-color: #FFE3E6!important;
      }
      .paid-status{
        background-color: #DCFFE4!important;
      }
      .unbuyable-status{
        background-color: #FFFBDD!important;
      }
      .void-color{
        color: #CB2431;
      }
      .incomplete-status{
        background: #FFFBDD;
      }
      .main-header{
        padding: 20px 70px 0px 70px;
        border-bottom: 1px solid #D1D5DA;
        background-color: #FFF!important;
        ::v-deep .el-tabs__header{
          margin-bottom: 0;
        }
        .margin-bottom{
          padding-bottom: 20px;
        }
      }
    }
  .bg-green {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #68C23A;
    color: white;
    p {
      padding-bottom: 5px;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-warning {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #e6a23d;
    color: white;
    p {
      padding-bottom: 5px;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-skyblue {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #409eff;
    color: white;
    p {
      padding-bottom: 5px;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-blue {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #d9ecff;
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
      display: block;
    }
  }
  .bg-yellow {
    margin: 0px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #FFFBDD;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    border: 1px solid rgba(176, 136, 0, 0.2);
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
      display: block;
    }
    .blue{
      color: $blue!important;
    }
    &.bg-blue{
      background: rgba(219, 237, 255, 1);
      border: 1px solid rgba(4, 66, 137, 0.2)
    }
  }
  .bg-gray {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 20px 15px;
    background: #91939a;
    color: white;
    p {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-small-blue {
    background: #B3D9FF;
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-block {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 20px 15px;
    p {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-green {
    background: #28a745;
    color: white;
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-red {
    background: #D73A49;
    color: white;
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-danger {
    background: #f56c6d;
    color: white;
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-b3d9ff {
    background: #b3d9ff;
  }
  .bg-warning {
    background: #e6a23d;
    color: white;
    .label {
      color: white;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  .bg-sky-blue {
    background: #409EFF;;
    color: white;
    .label {
      color: white;
    }
    .el-button{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
  ::v-deep .edit-container{
    padding: 0px!important;
  }
  .tr-margin{
    margin-bottom: 10px;
  }
  .setting-menu{
    list-style: none;
    background: #FFFFFF;
    //border: 1px solid #E1E4E8;
    border-radius: 6px;
    z-index: 100;
    margin-top: 0!important;
    position: absolute;
    margin-left: 22px;
    box-shadow: 0 1px 8px 0 rgba(27, 31, 35, 0.4);
    //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);

    li{
      width: 256px;
      height: 33px;
      background: #FFFFFF;
      font-family: Inter;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #24292E!important;
      box-shadow: inset 0px -1px 0px #E1E4E8;
      cursor: pointer;
      .with-icon{
        width: 11px!important;
      }
      i{
        width: 11px;
      }
      span{
        margin-left: 10px;
      }
      &:last-child{
        box-shadow: none!important;
      }
    }


  }
  .button-group{
    background: #FAFBFC;
    display: flex;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-sizing: border-box;
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);
    border-radius: 6px 6px 6px 6px;
    height: 32px;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;

    .span-one{
      .icon{
        font-family: Font Awesome 5 Free;
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        line-height: 16px;
        /* identical to box height, or 114% */

        display: flex;
        align-items: center;
        text-align: center;

        /* btn/outline/text */

        color: #0366D6;
      }
      span{
        margin-left: 10px;
      }
      color: #0366D6;
      border-right: 1px solid #E1E4E8;
      width: 60%;
      align-items: center;
      text-align: center;
      display: flex;
      cursor: pointer;
      height: 100%;
      justify-content: center;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
    }
    .span-two{
      color: #24292E;
      width: 40%;
      align-items: center;
      text-align: center;
      display: flex;
      cursor: pointer;
      height: 100%;
      justify-content: center;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      span{
        margin-right: 10px;
      }
    }
  }
  .bg-green {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #68C23A;
    color: white;
    p {
      padding-bottom: 5px;
    }
  }
  .bg-warning {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #e6a23d;
    color: white;
    p {
      padding-bottom: 5px;
    }
  }
  .bg-skyblue {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #409eff;
    color: white;
    p {
      padding-bottom: 5px;
    }
  }
  .bg-blue {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 15px 15px;
    background: #d9ecff;
  }
  .bg-gray {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 20px 15px;
    background: #91939a;
    color: white;
    p {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .bg-small-blue {
    background: #B3D9FF;
  }
  .bg-block {
    margin: -15px -15px 0 -15px;
    padding: 20px 15px 20px 15px;
    p {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
    }
    //display: flex;
    //flex-direction: column;
  }
  .bg-green {
    background: #28a745;
    color: white;
  }
  .bg-red {
    background: #D73A49;
    color: white;
  }
  .bg-danger {
    background: #f56c6d;
    color: white;
  }
  .bg-b3d9ff {
    background: #b3d9ff;
  }
  .bg-warning {
    background: #e6a23d;
    color: white;
    .label {
      color: white;
    }
  }
  .bg-sky-blue {
    background: #409EFF;;
    color: white;
    .label {
      color: white;
    }
  }
  .border-left-blue {
    border-left: 5px solid #409EFF;
  }
  .border-left-warning {
    border-left: 5px solid #E6A23D;
  }
  .border-left-success {
    border-left: 5px solid #68C23A;
  }
  .box {
    //margin-top: 15px;
    .title{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E;
    }
    .box-show{
      background: #F6F8FA;
      border-radius: 6px;
      padding: 10px;
      margin-bottom: 10px;
      margin-top: 10px;
      .title{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        color: #24292E;
      }
      .email{
        word-break: break-all;
        position: relative;
        .tips{
          position: absolute;
        }
      }
    }
  }

  .span-status{
    padding: 2px 10px;
    color: #fff;
    border-radius: 50px;
    font-size: 14px;
    margin-right: 10px;
  }
  .yellow{
    background-color: #DBAB09;
  }
  .purple{
    background-color: #6F42C1;
  }
  .green{
    background: #28A745;
    color: #28A745!important;
  }
  .status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    //height: 50px;
    color: white;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 30px;
    border: 1px solid rgba(23, 111, 44, 0.2);
    border-radius: 6px;
    &.snoozed {
      background: #E6A23D;
    }
    &.resolved {
      background: #DCFFE4;
      color: #24292E;
    }
    .check{
      color: #28A745!important;
    }
    .status-title {
      padding: 22px 0;
      span {
        display: flex;
        align-items: center;
      }
    }
    .svg-inline--fa {
      padding-right: 10px;
      color: white;
      font-size: 22px;
    }

  }
  .margin-top-none{
    margin-top: 0!important;
  }
  .main-header{
    background-color: #FFF!important;
    .button-radius{
      height: 18px;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #24292E;
      padding: 1px 8px;
      background: #FFFFFF;
      border: 1px solid #6A737D;
      border-radius: 100px;
    }
    .ticket-number{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E;
      height: 20px;
    }
    .header-title{
      h3{
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 36px;
        letter-spacing: 0.3px;
        color: #24292E;
      }
    }
    .flex-inline{
      align-items: flex-end;
    }
    .header-date{
      //height: 20px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      //line-height: 20px;
      color: #586069;
      margin-right: 0;
    }
    .number-fontsize{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      //line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-left: 8px;
      margin-right: 15px;
    }
  }
  .add-policy-list {
    margin-top: 15px;
    .add-policy-item {
      margin-bottom: 15px;
      font-size: 12px;
      color: white;
      .add-policy-label {
        display: block;
        padding-bottom: 5px;
        cursor: pointer;
        .ic-right {
          margin-left: 5px;
          font-size: 12px;
          font-weight: 400;
        }
      }
      .bold {
        font-weight: bold;
      }
    }
  }
  .button-margin{
    margin-right: 8px!important;
  }
  .icon-backgroud-none{
    background: none!important;
    img{
      height: auto!important;
    }
  }
  .policy-span-status {
    background: none;
    border: 0px!important;
    &.green {
      color: #28a745!important;
    }
    &.orange {
      color: #E36209!important;
    }
    &.yellow-dark {
      color: #DBAB09!important;
    }
    &.blue {
      color: #0366D6!important;
    }
    &.red {
      color: #d73a49!important;
    }
    &.min-green {
      color: #dcffe4;
    }
    &.purple {
      color: #6F42C1;
    }
  }
  .plan-name{
    text-decoration: none!important;
  }
  .flex-icon{
    width: 70px;
    margin-right: 5px;
    display: flex;
    .icon{
      margin-right: 10px!important;
    }
    .icon-margin-top{
      margin-top: -1px;
    }
    //con-width{
    //  width: 22px;
    //  margin-right: 10px;
    //}
  }

  .status-box{
    padding: 15px;
    width: 280px;
    border-radius: 15px;
    &.yellow-bg{
      background: #FFFBDD;
      border: 1px solid rgba(176, 136, 0, 0.2);
    }
    &.blue-bg{
      background: #DBEDFF;
      border: 1px solid rgba(4, 66, 137, 0.2);
    }
    &.green-bg{
      background: #DCFFE4;
      border: 1px solid rgba(23, 111, 44, 0.2);
    }
    &.red-bg{
      background: #FFE3E6;
      border: 1px solid rgba(158, 28, 35, 0.2);
    }
    .box-title{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      height: 20px;
    }
    .tips{
      font-weight: 400;
      font-size: 14px;
      margin-top: 10px;
    }
    .btn{
      margin-top: 10px;
      .el-button{
        height: 32px;
        border-radius: 6px;
        font-weight: 600;
        font-family: 'inter';
      }
      .green-btn{
        background: #2EA44F;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
        color: #FFFFFF;
        /deep/.icon{
          color: rgba(255, 255, 255, 0.8);
        }
      }
      .gray-red-btn{
        color: #D73A49;
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      }
      .gray-black-btn{
        color: #24292E;
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        /deep/.icon{
          color: #586069;
        }
      }
      .el-button+.el-button{
        margin: 0;
        margin-top: 10px;
      }
    }
  }
  span.edit{
    color: #0366D6;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
  }
  .description-content{
    font-weight: 400;
    font-size: 14px;
    color: #24292E;
    margin-bottom: 15px;
  }
</style>

